// import React, { useState, useEffect } from "react"
// import { Table } from "reactstrap"
// import { useNavigate, useParams } from "react-router-dom"
// import { Row, Form } from "reactstrap"
// import Select from "react-select"
// import Loader from "pages/Separate/Loader"
// import axios from "axios"
// import indiaFlag from "../../../../assets/images/flags/india.png"
// import UkFlag from "../../../../assets/images/flags/uk.png"
// import configure from "configure"

// const Profile = () => {
//   const [fixButtons, setFixButtons] = useState(false)
//   const [testingRows, setTestingRows] = useState([{}])
//   const [breakdownRows, setBreakdownRows] = useState([{}])
//   const [termsRows, setTermsRows] = useState([{}])

//   // For Client information
//   const [client, setClient] = useState([])

//   // for Provider Informtaion
//   const [providerInfo, setProviderInfo] = useState({})
//   const [relatedClient, setRelatedClient] = useState([])

//   const navigate = useNavigate()

//   useEffect(() => {
//     setLocation("India")
//     setProviderInfo(ukProvider)

//     setClient(introducer)
//   }, [])

//   // document.title = "Add General Proposal | Zithas Crm"

//   // dynamic Testing form add-remove
//   const onAddTestingRow = () => {
//     setTestingRows([...testingRows, {}])
//   }
//   const onDeleteTestingRow = index => {
//     const newInputs = [...testingRows]
//     newInputs.splice(index, 1)
//     setTestingRows(newInputs)
//   }

//   // dynamic breakdownRows Form add-remove
//   const onAddBreakdownRow = () => {
//     setBreakdownRows([...breakdownRows, {}])
//   }
//   const onDeleteBreakdownRow = index => {
//     const newInputs = [...breakdownRows]
//     newInputs.splice(index, 1)
//     setBreakdownRows(newInputs)
//   }

//   // dynamic Terms and agreement Form add-remove
//   const onAddTermsRow = () => {
//     setTermsRows([...termsRows, {}])
//   }
//   const onDeleteTermsRow = index => {
//     const newInputs = [...termsRows]
//     newInputs.splice(index, 1)
//     setTermsRows(newInputs)
//   }

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 160) {
//       setFixButtons(true)
//     } else {
//       setFixButtons(false)
//     }
//   })

//   const colourStyles = {
//     menuList: styles => ({
//       ...styles,
//       background: "white",
//     }),
//     menu: base => ({
//       ...base,
//       zIndex: 50,
//     }),
//   }

//   // for select controls

//   const related_option = [
//     { label: "Lead", value: "lead" },
//     { label: "Customer", value: "customer" },
//     { label: "Introducer", value: "introducer" },
//   ]
//   // ------------------------

//   // Clients
//   const introducer = [
//     { label: "Nothing Selected", value: "1" },
//     { label: "Jack Smith", value: "2" },
//     { label: "Test company", value: "3" },
//     { label: "Zenith Tins", value: "4" },
//     { label: "Julius Gohil", value: "5" },
//     { label: "Test Introducer", value: "6" },
//   ]

//   const ukProvider = {
//     companyName: "Zithas Technologies",
//     address: "Bristol, United Kingdom",
//     website: "https://www.zithas.co.uk",
//   }

//   //   All Use States
//   const [isLoading, setLoading] = useState([])
//   const [location_option, setLocationOption] = useState([])
//   const [status_option, setStatusOption] = useState([])
//   const [assign_option, setAssignOption] = useState([])
//   const [currency_option, setCurrencyOption] = useState([])
//   const [location, setLocation] = useState([])
//   const [proposal_title, setProposalTitle] = useState("")
//   const [proposal_subtitle, setProposalSubTitle] = useState("")
//   const [status, setStatus] = useState([])
//   const [currency, setCurrency] = useState([])
//   const [date, setDate] = useState("")
//   const [till_date, setTillDate] = useState("")
//   const [related, setRelated] = useState([])
//   const [lead_option, setLeadOption] = useState([])
//   const [company_name, setCompany_name] = useState("")
//   const [address, setAddress] = useState("")
//   const [website, setWebsite] = useState("")
//   const [person_name, setPersonName] = useState("")
//   const [person_email, setPersonEmail] = useState("")
//   const [person_phone, setPersonPhone] = useState("")
//   const [provider_company, setProviderCompany] = useState("")
//   const [provider_address, setProviderAddress] = useState("")
//   const [provider_website, setProviderWebsite] = useState("")
//   const [provider_person, setProviderPerson] = useState("")
//   const [provider_phone, setProviderPhone] = useState("")
//   const [provider_email, setProviderEmail] = useState("")
//   const [assign, setAssign] = useState([])
//   const [conclusion_email, setConclusionEmail] = useState("")
//   const [conclusion_phone, setConclusionPhone] = useState("")
//   const [source_id, setSourceId] = useState("")
//   const [contact_name_options, setContactPersionOptions] = useState([])
//   const [allIntroducers, setIntroducerOption] = useState([])
//   const [introducerId, setIntroducerId] = useState([])

//   //   show Proposal Data api Fetch

//   const params = useParams()

//   useEffect(() => {
//     FetchProposalData()
//   }, [])

//   const FetchProposalData = async () => {
//     setLoading(true)
//     const formData = new FormData()
//     formData.append("proposal_id", params.id)
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/view_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(async response => {
//         if (
//           response.data.data[0].proposaltitile != "undefined" &&
//           response.data.data[0].proposaltitile != "null"
//         )
//           setProposalTitle(response.data.data[0].proposaltitile)

//         if (
//           response.data.data[0].proposalsubtitle != "undefined" &&
//           response.data.data[0].proposalsubtitle != "null"
//         )
//           setProposalSubTitle(response.data.data[0].proposalsubtitle)
//         setDate(response.data.data[0].date)
//         setTillDate(response.data.data[0].opentill)
//         const currRelated = related_option.filter(
//           obj => obj.value == response.data.data[0].related
//         )[0]
//         setRelated(currRelated)

//         setCompany_name(response.data.data[0].companyname)

//         if (
//           response.data.data[0].address != "undefined" &&
//           response.data.data[0].address != "null"
//         )
//           setAddress(response.data.data[0].address)

//         if (
//           response.data.data[0].cilentcontact != "undefined" &&
//           response.data.data[0].cilentcontact != "null"
//         )
//           setPersonPhone(response.data.data[0].cilentcontact)

//         if (
//           response.data.data[0].email != "undefined" &&
//           response.data.data[0].email != "null"
//         )
//           setPersonEmail(response.data.data[0].email)

//         if (
//           response.data.data[0].website != "undefined" &&
//           response.data.data[0].website != "null"
//         )
//           setWebsite(response.data.data[0].website)
//         setProviderPerson(response.data.data[0].contactmember)
//         setProviderPhone(response.data.data[0].contact)
//         setProviderEmail(response.data.data[0].provideremail)
//         setProviderCompany(response.data.data[0].company2)
//         setProviderAddress(response.data.data[0].address1)
//         if (
//           response.data.data[0].website != "undefined" &&
//           response.data.data[0].website != "null"
//         )
//           setProviderWebsite(response.data.data[0].website1)

//         setTestingRows(JSON?.parse(response.data.data[0].deliverytesting))
//         setTermsRows(JSON?.parse(response.data.data[0].terms))

//         setBreakdownRows(JSON?.parse(response.data.data[0].costbreakdown))
//         if (
//           response.data.data[0].conclusion_email != "undefined" &&
//           response.data.data[0].conclusion_email != "null"
//         )
//           setConclusionEmail(response.data.data[0].conclusion_email)
//         if (
//           response.data.data[0].conclusion_contact != "undefined" &&
//           response.data.data[0].conclusion_contact != "null"
//         )
//           setConclusionPhone(response.data.data[0].conclusion_contact)

//         await axios({
//           method: "get",
//           url: `${configure.apiUrl}/locations`,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }).then(res => {
//           const option = res?.data.data.map(obj => ({
//             label: obj.location,
//             value: obj.id,
//             link: obj?.Link
//           }))
//           setLocationOption(option)
//           setLocation(response.data.data[0].location)
//           setLoading(false)
//         })

//         await axios({
//           method: "get",
//           url: `${configure.apiUrl}/currency`,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }).then(res => {
//           const option = res.data.data.currency.map(item => ({
//             label: item.currency,
//             value: item.id,
//             symbol: item.symbol,
//           }))
//           setCurrencyOption(option)
//           setCurrency(
//             option.filter(
//               obj => obj.value == response.data.data[0].currency_id
//             )[0]
//           )
//           setLoading(false)
//         })

//         await axios({
//           method: "get",
//           url: `${configure.apiUrl}/proposal_status`,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }).then(res3 => {
//           const option = res3.data.data.map(obj => ({
//             value: obj.id,
//             label: obj.name,
//           }))
//           setStatusOption(option)
//           setStatus(
//             option.filter(obj => obj.value == response.data.data[0].status)[0]
//           )
//         })

//         const fromData1 = new FormData()
//         fromData1.append("related", response.data.data[0].related)
//         fromData1.append("location", response.data.data[0].location)

//         await axios({
//           method: "post",
//           url: `${configure.apiUrl}/related`,
//           data: fromData1,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }).then(res2 => {
//           setLoading(false)

//           let options

//           if (response.data.data[0].related == "introducer") {
//             options = res2.data.data.map(obj => ({
//               value: obj.id,
//               label: obj.company,
//               address: obj.address,
//               details: obj.person_details,
//               website: obj.website,
//             }))
//           } else {
//             options = res2.data.data.map(obj => ({
//               value: obj.id,
//               label:
//                 obj.company +
//                 " - " +
//                 (obj.person_details[0]
//                   ? obj.person_details[0]?.person_name
//                   : "NA") + " - " + obj?.id,
//               companyName: obj.company,
//               address: obj.address,
//               details: obj.person_details,
//               website: obj.website,
//             }))
//           }

//           setLeadOption(options)

//           const temp = options.filter(
//             obj => obj.value == response.data.data[0].source_name
//           )[0]

//           // setTimeout(() => onClientInfo(temp), 2000)

//           setSourceId(temp)
//           setCompany_name(temp?.companyName)
//           if (temp?.details) {
//             const contact_person_options = temp?.details?.map(person => ({
//               label: person.person_name,
//               value: person,
//             }))
//             setContactPersionOptions(contact_person_options)
//             setPersonName(
//               contact_person_options.find(
//                 item => item.label == response.data.data[0].contactname
//               )
//             )
//           } else {
//             setPersonName(response.data.data[0].contactname)
//           }

//           // if (currRelated?.value == "lead") {
//           //   setPersonName(contact_person_options.find(item => item.label == response.data.data[0].contactname))
//           //   setAddress(temp.address)
//           //   setWebsite(temp.website)
//           // } else if (currRelated?.value == "customer") {
//           //   setPersonEmail(temp.details[0]?.email)
//           //   // setPersonName(temp.details[0]?.person_name)
//           //   setPersonPhone(temp.details[0]?.phone)
//           //   setAddress(temp.address)
//           //   setWebsite(temp.website)
//           // }

//           // onClientInfo(temp)
//         })

//         const fromData = new FormData()
//         fromData.append("country_id", response.data.data[0].location)
//         await axios({
//           method: "post",
//           url: `${configure.apiUrl}/lead_belong`,
//           data: fromData,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }).then(res => {
//           setAssignOption(
//             res.data.data.assigned?.map(item => ({
//               value: item.id,
//               label: item.name,
//             }))
//           )
//           setAssign(
//             res.data.data.assigned
//               ?.map(item => ({
//                 value: item.id,
//                 label: item.name,
//               }))
//               .filter(obj => obj.value == response.data.data[0].assignd)[0]
//           )
//           const introducers = res?.data?.data?.introducer?.map((obj) => ({
//             label: obj.company,
//             value: obj.id,
//           }))
//           setIntroducerId(introducers?.find((objs) => objs?.value == response.data.data[0].introducer_id))
//           setIntroducerOption(introducers)
//           setLoading(false)
//         })

//         setLoading(false)
//       })
//     } catch (err) {
//       console.log(err)
//       setLoading(false)
//     }
//   }

//   const onChangeCountry = async e => {
//     if (e.value == 1) {
//       setProviderCompany("Zithas Technologies.pvt.ltd")
//       // setProviderAddress("Gotri, Vadodara, Gujarat, India")
//       setProviderWebsite("www.zithas.com")
//     } else if (e.value == 2) {
//       setProviderCompany("Zithas Technologies")
//       // setProviderAddress("Bristol, United Kingdom")
//       setProviderWebsite("www.zithas.co.uk")
//     }

//     setLoading(true)
//     setLocation(e.target.value)
//     const fromData = new FormData()
//     fromData.append("country_id", e.target.value)
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(res => {
//         setAssignOption(
//           res.data.data.assigned?.map(item => ({
//             value: item.id,
//             label: item.name,
//           }))
//         )
//         setStatusOption(
//           res.data.data.lead_status.map(item => ({
//             value: item.id,
//             label: item.name,
//           }))
//         )
//         setLoading(false)
//       })
//     } catch (error) {
//       console.log(error)
//       setLoading(false)
//     }
//   }

//   const onChangeRelated = async e => {
//     console.log(e)
//     setRelated(e)
//     setRelatedClient(e)
//     setLoading(true)
//     setPersonEmail("")
//     setPersonName("")
//     setPersonPhone("")
//     setSourceId([])
//     setCompany_name("")
//     setWebsite("")
//     setAddress("")
//     const fromData = new FormData()
//     fromData.append("related", e.value)
//     fromData.append("location", location)
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/related`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(res => {
//         setLoading(false)

//         // console.log("Related", res)

//         if (res.data.success === true) {
//           if (e.value == "introducer") {
//             setLeadOption(
//               res.data.data.map(obj => ({
//                 value: obj.id,
//                 label: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               }))
//             )
//           } else {
//             setLeadOption(
//               res.data.data.map(obj => ({
//                 value: obj.id,
//                 label:
//                   obj.company +
//                   " - " +
//                   (obj.person_details[0]
//                     ? obj.person_details[0]?.person_name
//                     : "NA") + " - " + obj?.id,
//                 companyName: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               }))
//             )
//           }
//         }
//       })
//     } catch (error) {
//       console.log(error)
//       setLoading(false)
//     }
//   }

//   const onClientInfo = e => {
//     setSourceId(e)
//     setCompany_name(e?.companyName)

//     if (related?.value == "lead") {
//       setContactPersionOptions(
//         e.details.map(person => ({ label: person.person_name, value: person }))
//       )
//       // setPersonEmail(e.details[0]?.person_email)
//       // setPersonName(e.details[0]?.person_name)
//       // setPersonPhone(e.person_phone)
//       setAddress(e.address)
//       setWebsite(e.website)
//     } else if (related?.value == "customer") {
//       setContactPersionOptions(
//         e.details.map(person => ({ label: person.person_name, value: person }))
//       )

//       setPersonEmail(e.details[0]?.email)
//       // setPersonName(e.details[0]?.person_name)
//       setPersonPhone(e.details[0]?.phone)
//       setAddress(e.address)
//       setWebsite(e.website)
//     }
//   }

//   const onStaffDetail = async e => {
//     setProviderPerson(e.label)
//     setAssign(e)
//     setLoading(true)
//     try {
//       const response = await axios({
//         method: "get",
//         url: `${configure.apiUrl}/show/${e.value}`,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(response => {
//         setProviderPhone(response.data.data.staff.contact_number)
//         setProviderEmail(response.data.data.staff.email)

//         let city, state, country

//         Object.keys(response.data.data.staff).forEach(obj => {
//           switch (obj) {
//             case "ctname":
//               city =
//                 response.data.data.staff[obj] != null
//                   ? response.data.data.staff[obj]
//                   : "-"
//               break
//             case "sname":
//               state =
//                 response.data.data.staff[obj] != null
//                   ? response.data.data.staff[obj]
//                   : "-"
//               break
//             case "cname":
//               country =
//                 response.data.data.staff[obj] != null
//                   ? response.data.data.staff[obj]
//                   : "-"
//               break
//           }
//         })

//         setProviderAddress(`${city}, ${state}, ${country}`)

//         setLoading(false)
//       })
//     } catch (err) {
//       console.log(err)
//       setLoading(false)
//     }
//   }

//   // Testing Rows on Change Event
//   const testingSr = (e, key) => {
//     const updatedArray = [...testingRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTestingRows(updatedArray)
//   }
//   const testingMilestone = (e, key) => {
//     const updatedArray = [...testingRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTestingRows(updatedArray)
//   }
//   const testingTime = (e, key) => {
//     const updatedArray = [...testingRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTestingRows(updatedArray)
//   }

//   // Terms and Aggrement on Change Event

//   const termsSr = (e, key) => {
//     const updatedArray = [...termsRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTermsRows(updatedArray)
//   }
//   const termsService = (e, key) => {
//     const updatedArray = [...termsRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTermsRows(updatedArray)
//   }
//   const termsCurrency = (e, key) => {
//     const updatedArray = [...termsRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTermsRows(updatedArray)
//   }
//   const termsValue = (e, key) => {
//     const updatedArray = [...termsRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setTermsRows(updatedArray)
//   }

//   // Cost BreakDown on Change Event

//   const breakDescription = (e, key) => {
//     const updatedArray = [...breakdownRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setBreakdownRows(updatedArray)
//   }
//   const breakSr = (e, key) => {
//     const updatedArray = [...breakdownRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setBreakdownRows(updatedArray)
//   }
//   const breakTotal = (e, key) => {
//     const updatedArray = [...breakdownRows]
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     }
//     setBreakdownRows(updatedArray)
//   }

//   const onEditProposal = async e => {
//     e.preventDefault()
//     setLoading(true)
//     const formData = new FormData()
//     formData.append("user_id", localStorage.getItem("auth_id"))
//     formData.append("proposal_id", params.id)
//     formData.append("proposaltitle", proposal_title)
//     formData.append("proposalsubtitle", proposal_subtitle)
//     formData.append("currency", currency?.value)
//     formData.append("date", date)
//     formData.append("opentill", till_date)
//     formData.append("related", related?.value)
//     formData.append("companyname", company_name)
//     formData.append(
//       "contactname",
//       person_name?.label ? person_name?.label : person_name
//     )
//     formData.append("address", address)
//     formData.append("clientcontact", person_phone)
//     formData.append("email", person_email)
//     formData.append("website", website)
//     formData.append("assigned", assign?.value)
//     formData.append("company2", provider_company)
//     formData.append("contactnumber", provider_phone)
//     formData.append("address1", provider_address)
//     formData.append("providermail", provider_email)
//     formData.append("contact_member", provider_person)
//     formData.append("website1", provider_website)
//     formData.append("deliverytesting", JSON.stringify(testingRows))
//     formData.append("terms", JSON.stringify(termsRows))
//     formData.append("costbreakdown", JSON.stringify(breakdownRows))
//     formData.append("location", location)
//     formData.append("status", status?.value)
//     formData.append("conclusion_email", conclusion_email)
//     formData.append("conclusion_contact", conclusion_phone)
//     formData.append("source_name", source_id?.value)
//     formData.append("type", "General")
//     formData.append("introducer_id", introducerId?.value)
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/edit_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then(res => {
//         setLoading(false)
//         swal({
//           icon: "success",
//           text: "Proposal Edited Succesfully",
//         }).then(data => {
//           navigate(`${configure.appUrl}sales/proposal`)
//         })
//       })
//     } catch (error) {
//       console.log(error)
//       setLoading(false)
//     }
//   }

//   const onCurrency = (e, key) => {
//     let values = [...termsRows]
//     values[key][e.target.name] = e.target.value
//     setTermsRow(values)
//   }

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="ps-2">
//         <Row className="px-1">
//           <Form onSubmit={onEditProposal}>
//             {/* Fixed Buttons */}
//             <div
//               className={`flex-column fixed-buttons pt-2 ${fixButtons ? "d-flex" : "d-none"
//                 }`}
//             >
//               <button className="btn btn-save btn-label pe-0  fix-btn">
//                 <i className="fas fa-save me-2 label-icon"></i>
//                 <span>Save</span>
//               </button>
//               <a
//                 onClick={() => navigate(-1)}
//                 className="btn btn-red  fix-btn btn-label pe-0"
//               >
//                 <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                 <span>Cancel</span>
//               </a>
//             </div>
//             <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-3 mb-md-0 mb-3">
//                 <label htmlFor="">Location </label>
//                 <div className="row " style={{ marginLeft: "0px" }}>
//                   {location_option.map((item, i) => {
//                     return (
//                       <div className="form-check mb-2 col-md-4" key={i}>
//                         <input
//                           className="form-check-input input-location"
//                           type="radio"
//                           name="exampleRadios"
//                           id={`exampleRadios1${i}`}
//                           value={item.value}
//                           defaultChecked={location == item.value}
//                           onChange={onChangeCountry}
//                         />
//                         <label
//                           className="form-check-label pl-10"
//                           htmlFor={`exampleRadios1${i}`}
//                         >
//                           {item.value == 1 ? (
//                             <img
//                               src={item?.link}
//                               alt="no img"
//                               width="28"
//                               height="18"
//                               style={{ marginTop: "2px" }}
//                             />
//                           ) : (
//                             <img
//                               src={item?.link}
//                               alt="no img"
//                               width="28"
//                               height="18"
//                               style={{ marginTop: "2px" }}
//                             />
//                           )}
//                         </label>
//                       </div>
//                     )
//                   })}
//                 </div>
//               </div>
//               <div className="col-md-3 mb-3">
//                 <label htmlFor="">
//                   Introducer
//                 </label>
//                 <Select
//                   placeholder="Select Introducer"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={allIntroducers}
//                   value={introducerId}
//                   onChange={(e) => setIntroducerId(e)}
//                 />
//               </div>
//               <div className="col-md-6 mb-3 text-end">
//                 <button className=" btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={e => {
//                     e.preventDefault()
//                     navigate(-1)
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row>

//             {/* Service  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Service Information</h5>

//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Title</label>
//                 <input
//                   type="text"
//                   defaultValue="Software Development"
//                   placeholder="Enter Proposal Title"
//                   className="form-control "
//                   value={proposal_title}
//                   onChange={e => {
//                     setProposalTitle(e.target.value)
//                     let values = [...termsRows]
//                     values[1]["service"] = e.target.value
//                     setTermsRows(values)
//                   }}
//                 />
//               </div>
//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Subtitle</label>
//                 <input
//                   type="text"
//                   defaultValue="Zithas Mars - Payroll Management"
//                   placeholder="Enter Proposal Subtitle"
//                   className="form-control "
//                   value={proposal_subtitle}
//                   onChange={e => setProposalSubTitle(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Status</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={status_option}
//                   value={status}
//                   onChange={e => setStatus(e)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Currency</label>
//                 <Select
//                   placeholder="Select Currency"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={currency_option}
//                   value={currency}
//                   onChange={e => setCurrency(e)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Date</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={date}
//                   onChange={e => setDate(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Open Till</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={till_date}
//                   onChange={e => setTillDate(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Related </label>
//                 <Select
//                   placeholder="Select"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={related_option}
//                   value={related}
//                   onChange={e => onChangeRelated(e)}
//                 />
//               </div>
//             </Row>

//             {/* Client  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Client Information</h5>

//               {related?.label !== "Nothing Selected" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">{related?.label}</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={lead_option}
//                     value={source_id}
//                     onChange={e => onClientInfo(e)}
//                   />
//                 </div>
//               ) : null}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={company_name}
//                   onChange={e => setCompany_name(e.target.value)}
//                 />
//               </div>
//               {/* <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={person_name}
//                   onChange={e => setPersonName(e.target.value)}
//                 />
//               </div> */}

//               {related?.label == "Introducer" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Contact Person"
//                     className="form-control "
//                     value={person_name}
//                     onChange={e => setPersonName(e.target.value)}
//                   />
//                 </div>
//               ) : (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={contact_name_options}
//                     value={person_name}
//                     onChange={e => {
//                       setPersonName(e)
//                       console.log(e)
//                       setPersonEmail(e?.value.person_email)
//                       setPersonPhone(e?.value.person_phone)
//                     }}
//                   />
//                 </div>
//               )}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={address}
//                   onChange={e => setAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="number"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={person_phone}
//                   onChange={e => setPersonPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={person_email}
//                   onChange={e => setPersonEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Website</label>

//                 <input
//                   type="text"
//                   placeholder="Enter URL"
//                   className="form-control "
//                   value={website}
//                   onChange={e => setWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>

//             {/* Provider  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Provider Information</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Assigned</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={assign_option}
//                   value={assign}
//                   onChange={e => onStaffDetail(e)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={provider_person}
//                   onChange={e => setProviderPerson(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={provider_phone}
//                   onChange={e => setProviderPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   defaultValue="gia@zithas.com"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={provider_email}
//                   onChange={e => setProviderEmail(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={provider_company}
//                   onChange={e => setProviderCompany(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={provider_address}
//                   onChange={e => setProviderAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Website</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Website"
//                   className="form-control "
//                   value={provider_website}
//                   onChange={e => setProviderWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>

//             {/* Deliverables & testing info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Deliverables & testing</h5>
//                 <a
//                   onClick={() => onAddTestingRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Milestone Description</th>
//                       <th>Estimated Time (In Weeks)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(testingRows || []).map((testingRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               value={testingRow["sr.no"]}
//                               className="form-control "
//                               onChange={e => testingSr(e, key)}
//                               name="sr.no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               value={testingRow.milestone}
//                               placeholder="Enter Description"
//                               className="form-control "
//                               onChange={e => testingMilestone(e, key)}
//                               name="milestone"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               value={testingRow.estimatedtime}
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               onChange={e => testingTime(e, key)}
//                               name="estimatedtime"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteTestingRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Terms and agreement */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Terms and agreement</h5>
//                 <a
//                   onClick={() => onAddTermsRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Particular</th>
//                       <th>Currency</th>
//                       <th>Total</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(termsRows || []).map((termsRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={termsRow.no}
//                               onChange={e => termsSr(e, key)}
//                               name="no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={termsRow.service}
//                               onChange={e => termsService(e, key)}
//                               name="service"
//                             />
//                           </td>
//                           <td className="col-1">
//                             <input
//                               type="text"
//                               className="form-control "
//                               value={currency?.symbol}
//                               // onChange={e => onCurrency(e, key)}
//                               // value={termsRow.currency}
//                               // onChange={e => termsCurrency(e, key)}
//                               name="currency"
//                               readOnly
//                             />
//                           </td>
//                           <td className="col-2">
//                             <input
//                               type="text"
//                               placeholder="Enter Total"
//                               className="form-control "
//                               value={termsRow.total}
//                               onChange={e => termsValue(e, key)}
//                               name="total"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             <a
//                               onClick={() => onDeleteTermsRow(key)}
//                               className="btn btn-outline-danger"
//                             >
//                               <i className="fas fa-trash-alt"></i>
//                             </a>
//                           </td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Cost Breakdown info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Cost Breakdown</h5>
//                 <a
//                   onClick={() => onAddBreakdownRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Description</th>
//                       <th>Estimated Time (In Weeks)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(breakdownRows || []).map((breakdownRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={breakdownRow.sr_no}
//                               onChange={e => breakSr(e, key)}
//                               name="sr_no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={breakdownRow.description}
//                               onChange={e => breakDescription(e, key)}
//                               name="description"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               value={breakdownRow.totalcost}
//                               onChange={e => breakTotal(e, key)}
//                               name="totalcost"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteBreakdownRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       )
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Conclusion*/}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Conclusion</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={conclusion_email}
//                   onChange={e => setConclusionEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Phone Number</label>
//                 <input
//                   type="text"
//                   value={conclusion_phone}
//                   onChange={e => setConclusionPhone(e.target.value)}
//                   placeholder="Enter Phone no."
//                   className="form-control "
//                 />
//               </div>
//             </Row>
//           </Form>
//         </Row>
//       </div>
//     </React.Fragment>
//   )
// }

// export default Profile


// import React, { useState, useEffect } from "react";
// import { Table } from "reactstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import { Row, Form } from "reactstrap";
// import Select from "react-select";
// import Loader from "pages/Separate/Loader";
// import axios from "axios";
// import indiaFlag from "../../../../assets/images/flags/india.png";
// import UkFlag from "../../../../assets/images/flags/uk.png";
// import configure from "configure";
// import Swal from "sweetalert2";

// const Profile = () => {
//   const [fixButtons, setFixButtons] = useState(false);
//   const [testingRows, setTestingRows] = useState([{}]);
//   const [breakdownRows, setBreakdownRows] = useState([{}]);
//   // const [termsRows, setTermsRows] = useState([{}]);
//   const [termsRows, setTermsRows] = useState([
//     {
//       no: "1",
//       service: "Project duration",
//       currency: "£",
//       total: "",
//     },
//     {
//       no: "2",
//       service: "(Service Name)",
//       currency: "£",
//       total: "",
//     },
//     {
//       no: "3",
//       service: "Domain, Hosting, and SSL (Annual Charges)",
//       currency: "£",
//       total: "",
//     },
//   ]);

//   // For Client information
//   const [client, setClient] = useState([]);

//   // for Provider Informtaion
//   const [providerInfo, setProviderInfo] = useState({});
//   const [relatedClient, setRelatedClient] = useState([]);

//   const [template, setTemplate] = useState({ value: "1", label: "Template 1" });
//   const template_options = [
//     { label: "Template 1", value: "1" },
//     { label: "Blank Template", value: "2" },
//   ];

//   // const FIXED_PHASES = [
//   //   "Discovery & Strategy",
//   //   "UI/UX Design",
//   //   "Development",
//   //   "Content Integration",
//   //   "QA & Testing",
//   //   "Deployment",
//   // ];

//   // const [timelineRows, setTimelineRows] = useState(
//   //   FIXED_PHASES.map((phase) => ({ phase, duration: "", deliverables: "" })),
//   // );

//   const [timelineRows, setTimelineRows] = useState([
//     { phase: "Discovery & Strategy", duration: "", deliverables: "" },
//     { phase: "UI/UX Design", duration: "", deliverables: "" },
//     { phase: "Development", duration: "", deliverables: "" },
//     { phase: "Content Integration", duration: "", deliverables: "" },
//     { phase: "QA & Testing", duration: "", deliverables: "" },
//     { phase: "Deployment", duration: "", deliverables: "" },
//   ]);

//   const navigate = useNavigate();

//   useEffect(() => {
//     setLocation("India");
//     setProviderInfo(ukProvider);

//     setClient(introducer);
//   }, []);

//   // document.title = "Add General Proposal | Zithas Crm"

//   // dynamic Testing form add-remove
//   const onAddTestingRow = () => {
//     setTestingRows([
//       ...testingRows,
//       { "sr.no": testingRows.length + 1, milestone: "", estimatedtime: "" },
//     ]);
//   };

//   const onDeleteTestingRow = (index) => {
//     const newInputs = [...testingRows];
//     newInputs.splice(index, 1);
//     setTestingRows(newInputs);
//   };

//   // dynamic breakdownRows Form add-remove
//   const onAddBreakdownRow = () => {
//     setBreakdownRows([
//       ...breakdownRows,
//       { sr_no: breakdownRows.length + 1, description: "", totalcost: "" },
//     ]);
//   };

//   const onDeleteBreakdownRow = (index) => {
//     const newInputs = [...breakdownRows];
//     newInputs.splice(index, 1);
//     setBreakdownRows(newInputs);
//   };

//   // dynamic Terms and agreement Form add-remove

//   const onAddTermsRow = () => {
//     setTermsRows([
//       ...termsRows,
//       { no: termsRows.length + 1, service: "", value: "" },
//     ]);
//   };

//   const onDeleteTermsRow = (index) => {
//     const newInputs = [...termsRows];
//     newInputs.splice(index, 1);
//     setTermsRows(newInputs);
//   };

//   const onTimelineChange = (e, key) => {
//     const updated = [...timelineRows];
//     updated[key] = { ...updated[key], [e.target.name]: e.target.value };
//     setTimelineRows(updated);
//   };

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 160) {
//       setFixButtons(true);
//     } else {
//       setFixButtons(false);
//     }
//   });

//   const colourStyles = {
//     menuList: (styles) => ({
//       ...styles,
//       background: "white",
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 50,
//     }),
//   };

//   // for select controls

//   const related_option = [
//     { label: "Lead", value: "lead" },
//     { label: "Customer", value: "customer" },
//     { label: "Introducer", value: "introducer" },
//   ];
//   // ------------------------

//   // Clients
//   const introducer = [
//     { label: "Nothing Selected", value: "1" },
//     { label: "Jack Smith", value: "2" },
//     { label: "Test company", value: "3" },
//     { label: "Zenith Tins", value: "4" },
//     { label: "Julius Gohil", value: "5" },
//     { label: "Test Introducer", value: "6" },
//   ];

//   const ukProvider = {
//     companyName: "Zithas Technologies",
//     address: "Bristol, United Kingdom",
//     website: "https://www.zithas.co.uk",
//   };

//   //   All Use States
//   const [isLoading, setLoading] = useState([]);
//   const [location_option, setLocationOption] = useState([]);
//   const [status_option, setStatusOption] = useState([]);
//   const [assign_option, setAssignOption] = useState([]);
//   const [currency_option, setCurrencyOption] = useState([]);
//   const [location, setLocation] = useState([]);
//   const [proposal_title, setProposalTitle] = useState("");
//   const [proposal_subtitle, setProposalSubTitle] = useState("");
//   const [status, setStatus] = useState([]);
//   const [currency, setCurrency] = useState([]);
//   const [date, setDate] = useState("");
//   const [till_date, setTillDate] = useState("");
//   const [related, setRelated] = useState([]);
//   const [lead_option, setLeadOption] = useState([]);
//   const [company_name, setCompany_name] = useState("");
//   const [address, setAddress] = useState("");
//   const [website, setWebsite] = useState("");
//   const [person_name, setPersonName] = useState("");
//   const [person_email, setPersonEmail] = useState("");
//   const [person_phone, setPersonPhone] = useState("");
//   const [provider_company, setProviderCompany] = useState("");
//   const [provider_address, setProviderAddress] = useState("");
//   const [provider_website, setProviderWebsite] = useState("");
//   const [provider_person, setProviderPerson] = useState("");
//   const [provider_phone, setProviderPhone] = useState("");
//   const [provider_email, setProviderEmail] = useState("");
//   const [assign, setAssign] = useState([]);
//   const [conclusion_email, setConclusionEmail] = useState("");
//   const [conclusion_phone, setConclusionPhone] = useState("");
//   const [source_id, setSourceId] = useState("");
//   const [contact_name_options, setContactPersionOptions] = useState([]);
//   const [allIntroducers, setIntroducerOption] = useState([]);
//   const [introducerId, setIntroducerId] = useState([]);
//   const [project_objective, setProjectObjective] = useState("");
//   const [isGeneratingObjective, setIsGeneratingObjective] = useState(false);

//   //   show Proposal Data api Fetch

//   const params = useParams();

//   useEffect(() => {
//     FetchProposalData();
//   }, []);

//   const FetchProposalData = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("proposal_id", params.id);

//     try {
//       // ✅ Run proposal fetch + all dropdown APIs in parallel
//       const [response, curRes, statusRes] = await Promise.all([
//         axios({
//           method: "post",
//           url: `${configure.nodeApi}/view_proposal`,
//           data: formData,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }),
//         axios.get(`${configure.nodeApi}/currency`, {
//           headers: { Accept: "application/json" },
//         }),
//         axios.get(`${configure.apiUrl}/proposal_status`, {
//           headers: { Accept: "application/json" },
//         }),
//       ]);

//       // ✅ Set currency options regardless of proposal data
//       const curOptions = curRes.data.data.currency.map((item) => ({
//         label: item.currency,
//         value: item.id,
//         symbol: item.symbol,
//       }));
//       setCurrencyOption(curOptions);

//       // ✅ Set status options regardless of proposal data
//       const statusOptions = statusRes.data.data.map((obj) => ({
//         value: obj.id,
//         label: obj.name,
//       }));
//       setStatusOption(statusOptions);

//       const d = response.data.data[0];
//       console.log("RAW proposal data:", d);

//       // ✅ Set simple text fields safely
//       if (d.proposaltitile && d.proposaltitile !== "null")
//         setProposalTitle(d.proposaltitile);
//       if (d.proposalsubtitle && d.proposalsubtitle !== "null")
//         setProposalSubTitle(d.proposalsubtitle);
//       if (d.date) setDate(d.date);
//       if (d.opentill) setTillDate(d.opentill);
//       if (d.companyname) setCompany_name(d.companyname);
//       if (d.address && d.address !== "null") setAddress(d.address);
//       if (d.cilentcontact && d.cilentcontact !== "null")
//         setPersonPhone(d.cilentcontact);
//       if (d.email && d.email !== "null") setPersonEmail(d.email);
//       if (d.website && d.website !== "null") setWebsite(d.website);
//       if (d.contactmember) setProviderPerson(d.contactmember);
//       if (d.contact) setProviderPhone(d.contact);
//       if (d.provideremail) setProviderEmail(d.provideremail);
//       if (d.company2) setProviderCompany(d.company2);
//       if (d.address1) setProviderAddress(d.address1);
//       if (d.website1 && d.website1 !== "null") setProviderWebsite(d.website1);
//       if (d.conclusion_email && d.conclusion_email !== "null")
//         setConclusionEmail(d.conclusion_email);
//       if (d.conclusion_contact && d.conclusion_contact !== "null")
//         setConclusionPhone(d.conclusion_contact);
//       if (d.template) {
//         setTemplate(
//           template_options.find((o) => o.value == d.template) || {
//             value: "1",
//             label: "Template 1",
//           },
//         );
//       }
//       if (d.timeline) {
//         try {
//           const saved = JSON.parse(d.timeline);
//           // setTimelineRows(
//           //   FIXED_PHASES.map((phase, i) => ({
//           //     phase,
//           //     duration: saved[i]?.duration || "",
//           //     deliverables: saved[i]?.deliverables || "",
//           //   })),
//           // );
//           setTimelineRows(
//             saved.map((row) => ({
//               phase: row.phase || "",
//               duration: row.duration || "",
//               deliverables: row.deliverables || "",
//             })),
//           );
//         } catch {
//           // leave defaults
//         }
//       }
//       if (d.project_objective && d.project_objective !== "null")
//         setProjectObjective(d.project_objective);

//       try {
//         setTestingRows(JSON.parse(d.deliverytesting) || [{}]);
//       } catch {
//         setTestingRows([{}]);
//       }
//       try {
//         setTermsRows(JSON.parse(d.terms) || [{}]);
//       } catch {
//         setTermsRows([{}]);
//       }
//       try {
//         setBreakdownRows(JSON.parse(d.costbreakdown) || [{}]);
//       } catch {
//         setBreakdownRows([{}]);
//       }

//       // ✅ Match dropdowns with proposal data
//       setCurrency(curOptions.find((obj) => obj.value == d.currency_id) || null);
//       setStatus(statusOptions.find((obj) => obj.value == d.status) || null);
//       setRelated(related_option.find((obj) => obj.value === d.related) || null);

//       // ✅ location — use fallback if null
//       const locationId = d.location || 1;
//       setLocation(locationId);

//       // ✅ lead_belong for assignee + introducer options (always call regardless)
//       const belongForm = new FormData();
//       belongForm.append("country_id", locationId);
//       const belongRes = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: belongForm,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const assignOptions =
//         belongRes.data.data.assigned?.map((item) => ({
//           value: item.id,
//           label: item.name,
//         })) || [];
//       setAssignOption(assignOptions);
//       // setAssign(assignOptions.find(obj => obj.value == d.assignd) || null)

//       const matchedAssign =
//         assignOptions.find((obj) => obj.value == d.assignd) || null;
//       setAssign(matchedAssign);
//       if (matchedAssign) await fetchStaffDetail(matchedAssign); // ✅ auto-fill

//       const introducerOptions =
//         belongRes.data.data.introducer?.map((obj) => ({
//           label: obj.company,
//           value: obj.id,
//         })) || [];
//       setIntroducerOption(introducerOptions);
//       setIntroducerId(
//         introducerOptions.find((obj) => obj.value == d.introducer_id) || null,
//       );

//       // ✅ related clients — only call if related is set
//       if (d.related) {
//         const relatedForm = new FormData();
//         relatedForm.append("related", d.related);
//         relatedForm.append("location", locationId);
//         const relatedRes = await axios({
//           method: "post",
//           url: `${configure.nodeApi}/related`,
//           data: relatedForm,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         let leadOptions = [];
//         if (d.related === "introducer") {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         } else {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: `${obj.company || "N/A"} - ${
//               obj.person_details?.[0]?.person_name || "NA"
//             } - ${obj.id}`,
//             companyName: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         }
//         setLeadOption(leadOptions);

//         const selectedSource =
//           leadOptions.find((obj) => obj.value == d.source_name) || null;
//         setSourceId(selectedSource);
//         if (selectedSource?.companyName)
//           setCompany_name(selectedSource.companyName);

//         if (selectedSource?.details) {
//           const contactOptions = selectedSource.details.map((person) => ({
//             label: person.person_name,
//             value: person,
//           }));
//           setContactPersionOptions(contactOptions);
//           setPersonName(
//             contactOptions.find((item) => item.label === d.contactname) || null,
//           );
//         } else {
//           setPersonName(d.contactname || "");
//         }
//       }
//     } catch (err) {
//       console.error("FetchProposalData error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onChangeCountry = async (e) => {
//     if (e.value == 1) {
//       setProviderCompany("Zithas Technologies.pvt.ltd");
//       // setProviderAddress("Gotri, Vadodara, Gujarat, India")
//       setProviderWebsite("www.zithas.com");
//     } else if (e.value == 2) {
//       setProviderCompany("Zithas Technologies");
//       // setProviderAddress("Bristol, United Kingdom")
//       setProviderWebsite("www.zithas.co.uk");
//     }

//     setLoading(true);
//     setLocation(e.target.value);
//     const fromData = new FormData();
//     fromData.append("country_id", e.target.value);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setAssignOption(
//           res.data.data.assigned?.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setStatusOption(
//           res.data.data.lead_status.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setLoading(false);
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onChangeRelated = async (e) => {
//     console.log(e);
//     setRelated(e);
//     setRelatedClient(e);
//     setLoading(true);
//     setPersonEmail("");
//     setPersonName("");
//     setPersonPhone("");
//     setSourceId([]);
//     setCompany_name("");
//     setWebsite("");
//     setAddress("");
//     const fromData = new FormData();
//     fromData.append("related", e.value);
//     fromData.append("location", location);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.nodeApi}/related`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);

//         // console.log("Related", res)

//         if (res.data.success === true) {
//           if (e.value == "introducer") {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           } else {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label:
//                   obj.company +
//                   " - " +
//                   (obj.person_details[0]
//                     ? obj.person_details[0]?.person_name
//                     : "NA") +
//                   " - " +
//                   obj?.id,
//                 companyName: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           }
//         }
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onClientInfo = (e) => {
//     setSourceId(e);
//     setCompany_name(e?.companyName);

//     if (related?.value == "lead") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );
//       // setPersonEmail(e.details[0]?.person_email)
//       // setPersonName(e.details[0]?.person_name)
//       // setPersonPhone(e.person_phone)
//       setAddress(e.address);
//       setWebsite(e.website);
//     } else if (related?.value == "customer") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );

//       setPersonEmail(e.details[0]?.email);
//       // setPersonName(e.details[0]?.person_name)
//       setPersonPhone(e.details[0]?.phone);
//       setAddress(e.address);
//       setWebsite(e.website);
//     }
//   };

//   const fetchStaffDetail = async (staffOption) => {
//     if (!staffOption) return;
//     try {
//       const res = await axios.get(
//         `${configure.apiUrl}/show/${staffOption.value}`,
//         {
//           headers: { Accept: "application/json" },
//         },
//       );
//       const staff = res.data.data.staff;
//       setProviderPerson(staffOption.label);
//       setProviderPhone(staff.contact_number || "");
//       setProviderEmail(staff.email || "");
//       setProviderAddress(
//         `${staff.ctname || "-"}, ${staff.sname || "-"}, ${staff.cname || "-"}`,
//       );
//     } catch (err) {
//       console.error("fetchStaffDetail error:", err);
//     }
//   };

//   const onStaffDetail = async (e) => {
//     setAssign(e);
//     setLoading(true);
//     await fetchStaffDetail(e);
//     setLoading(false);
//   };

//   // Testing Rows on Change Event
//   const testingSr = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingMilestone = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingTime = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };

//   // Terms and Aggrement on Change Event

//   const termsSr = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsService = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsCurrency = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsValue = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };

//   // Cost BreakDown on Change Event

//   const breakDescription = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakSr = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakTotal = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };

//   const generateObjective = async () => {
//     if (!source_id?.value) {
//       return Swal.fire({ icon: "warning", text: "Please select a lead first" });
//     }
//     setIsGeneratingObjective(true);
//     try {
//       const rfpRes = await axios.get(
//         `${configure.nodeApi}/get_rfp_by_lead/${source_id.value}`,
//         { headers: { Accept: "application/json" } },
//       );
//       if (!rfpRes.data.success || !rfpRes.data.data) {
//         return Swal.fire({
//           icon: "warning",
//           text: "No RFP found for this lead to generate objective",
//         });
//       }
//       const rfp = rfpRes.data.data;
//       const features = (() => {
//         try {
//           const r = rfp.features;
//           return typeof r === "string" ? JSON.parse(r) : r || [];
//         } catch {
//           return [];
//         }
//       })();
//       const services = (() => {
//         try {
//           const r = rfp.services;
//           return typeof r === "string" ? JSON.parse(r) : r || [];
//         } catch {
//           return [];
//         }
//       })();
//       const res = await axios.post(
//         `${configure.nodeApi}/generate_project_objective`,
//         { company_name: company_name || "The Client", features, services },
//         { headers: { Accept: "application/json" } },
//       );
//       if (res.data.success) {
//         setProjectObjective(res.data.objective);
//       } else {
//         Swal.fire({ icon: "error", text: "Failed to generate objective" });
//       }
//     } catch (err) {
//       console.error("generateObjective error:", err);
//       Swal.fire({ icon: "error", text: "Failed to generate objective" });
//     } finally {
//       setIsGeneratingObjective(false);
//     }
//   };

//   const onEditProposal = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("proposal_id", params.id);
//     formData.append("proposaltitle", proposal_title);
//     formData.append("proposalsubtitle", proposal_subtitle);
//     formData.append("currency", currency?.value);
//     formData.append("date", date);
//     formData.append("opentill", till_date);
//     formData.append("related", related?.value);
//     formData.append("companyname", company_name);
//     formData.append(
//       "contactname",
//       person_name?.label ? person_name?.label : person_name,
//     );
//     formData.append("address", address);
//     formData.append("clientcontact", person_phone);
//     formData.append("email", person_email);
//     formData.append("website", website);
//     formData.append("assigned", assign?.value);
//     formData.append("company2", provider_company);
//     formData.append("contactnumber", provider_phone);
//     formData.append("address1", provider_address);
//     formData.append("providermail", provider_email);
//     formData.append("contact_member", provider_person);
//     formData.append("website1", provider_website);
//     formData.append("deliverytesting", JSON.stringify(testingRows));
//     formData.append("terms", JSON.stringify(termsRows));
//     formData.append("costbreakdown", JSON.stringify(breakdownRows));
//     formData.append("location", location);
//     formData.append("status", status?.value);
//     formData.append("conclusion_email", conclusion_email);
//     formData.append("conclusion_contact", conclusion_phone);
//     formData.append("source_name", source_id?.value);
//     formData.append("type", "General");
//     formData.append("introducer_id", introducerId?.value);
//     formData.append("template", template?.value || "1");
//     formData.append("timeline", JSON.stringify(timelineRows));
//     formData.append("project_objective", project_objective);
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.nodeApi}/edit_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);
//         swal({
//           icon: "success",
//           text: "Proposal Edited Succesfully",
//         }).then((data) => {
//           navigate(`${configure.appUrl}sales/proposal`);
//         });
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onCurrency = (e, key) => {
//     let values = [...termsRows];
//     values[key][e.target.name] = e.target.value;
//     setTermsRow(values);
//   };

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="ps-2">
//         <Row className="px-1">
//           <Form onSubmit={onEditProposal}>
//             {/* Fixed Buttons */}
//             <div
//               className={`flex-column fixed-buttons pt-2 ${
//                 fixButtons ? "d-flex" : "d-none"
//               }`}
//             >
//               <button className="btn btn-save btn-label pe-0  fix-btn">
//                 <i className="fas fa-save me-2 label-icon"></i>
//                 <span>Save</span>
//               </button>
//               <a
//                 onClick={() => navigate(-1)}
//                 className="btn btn-red  fix-btn btn-label pe-0"
//               >
//                 <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                 <span>Cancel</span>
//               </a>
//             </div>
//             {/* <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-3 mb-md-0 mb-3">
//                 <label htmlFor="">Introducer</label>
//                 <Select
//                   placeholder="Select Introducer"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={allIntroducers}
//                   value={introducerId}
//                   onChange={(e) => setIntroducerId(e)}
//                 />
//               </div>
              
//               <div className="col-md-3 mb-3"></div>
//               <div className="col-md-6 mb-3 text-end">
//                 <button className=" btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(-1);
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row> */}

//             <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-6 mb-md-0 mb-3">
//                 <div className="d-flex gap-3">
//                   <div className="flex-fill">
//                     <label htmlFor="">Introducer</label>
//                     <Select
//                       placeholder="Select Introducer"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       styles={colourStyles}
//                       options={allIntroducers}
//                       value={introducerId}
//                       onChange={(e) => setIntroducerId(e)}
//                     />
//                   </div>

//                   <div className="flex-fill">
//                     <label htmlFor="">Template</label>
//                     <Select
//                       placeholder="Select Template"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       style={{ backgroundColor: "#f8f6ff" }}
//                       options={template_options}
//                       value={template}
//                       onChange={(e) => setTemplate(e)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="col-md-6 mb-3 text-end d-flex align-items-end justify-content-end">
//                 <button className="btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(-1);
//                   }}
//                   className="btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row>

//             {/* Service  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Service Information</h5>

//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Title</label>
//                 <input
//                   type="text"
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   defaultValue="Software Development"
//                   placeholder="Enter Proposal Title"
//                   className="form-control "
//                   value={proposal_title}
//                   onChange={(e) => {
//                     setProposalTitle(e.target.value);
//                     let values = [...termsRows];
//                     values[1]["service"] = e.target.value;
//                     setTermsRows(values);
//                   }}
//                 />
//               </div>
//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Subtitle</label>
//                 <input
//                   type="text"
//                   defaultValue="Zithas Mars - Payroll Management"
//                   placeholder="Enter Proposal Subtitle"
//                   className="form-control"
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   value={proposal_subtitle}
//                   onChange={(e) => setProposalSubTitle(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Status</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={status_option}
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   value={status}
//                   onChange={(e) => setStatus(e)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Currency</label>
//                 <Select
//                   placeholder="Select Currency"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={currency_option}
//                   value={currency}
//                   onChange={(e) => setCurrency(e)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Date</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Open Till</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={till_date}
//                   onChange={(e) => setTillDate(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Related </label>
//                 <Select
//                   placeholder="Select"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={related_option}
//                   value={related}
//                   onChange={(e) => onChangeRelated(e)}
//                 />
//               </div>
//             </Row>

//             {/* Client  info */}
//             {template?.value !== "2" && (
//               <Row className="bg-white px-2 py-4 shadow mb-3">
//                 <h5 className="mb-3">Client Information</h5>

//                 {related?.label !== "Nothing Selected" ? (
//                   <div className="col-md-3 mt-2 mb-3">
//                     <label htmlFor="">{related?.label}</label>
//                     <Select
//                       placeholder="Select"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       styles={colourStyles}
//                       options={lead_option}
//                       value={source_id}
//                       onChange={(e) => onClientInfo(e)}
//                     />
//                   </div>
//                 ) : null}

//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Company Name</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Company Name"
//                     className="form-control "
//                     value={company_name}
//                     onChange={(e) => setCompany_name(e.target.value)}
//                   />
//                 </div>
//                 {/* <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={person_name}
//                   onChange={e => setPersonName(e.target.value)}
//                 />
//               </div> */}

//                 {related?.label == "Introducer" ? (
//                   <div className="col-md-3 mt-2 mb-3">
//                     <label htmlFor="">Contact Person</label>
//                     <input
//                       type="text"
//                       placeholder="Enter Contact Person"
//                       className="form-control "
//                       value={person_name}
//                       onChange={(e) => setPersonName(e.target.value)}
//                     />
//                   </div>
//                 ) : (
//                   <div className="col-md-3 mt-2 mb-3">
//                     <label htmlFor="">Contact Person</label>
//                     <Select
//                       placeholder="Select"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       styles={colourStyles}
//                       options={contact_name_options}
//                       value={person_name}
//                       onChange={(e) => {
//                         setPersonName(e);
//                         console.log(e);
//                         setPersonEmail(e?.value.person_email);
//                         setPersonPhone(e?.value.person_phone);
//                       }}
//                     />
//                   </div>
//                 )}

//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Address</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Address"
//                     className="form-control "
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mb-3 mb-md-0">
//                   <label htmlFor="">Contact</label>
//                   <input
//                     type="number"
//                     placeholder="Enter Contact"
//                     className="form-control "
//                     value={person_phone}
//                     onChange={(e) => setPersonPhone(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mb-3 mb-md-0">
//                   <label htmlFor="">Email Id</label>
//                   <input
//                     type="email"
//                     placeholder="Enter Email Id"
//                     className="form-control "
//                     value={person_email}
//                     onChange={(e) => setPersonEmail(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mb-3 mb-md-0">
//                   <label htmlFor="">Website</label>

//                   <input
//                     type="text"
//                     placeholder="Enter URL"
//                     className="form-control "
//                     value={website}
//                     onChange={(e) => setWebsite(e.target.value)}
//                   />
//                 </div>
//               </Row>
//             )}

//             {/* Provider  info */}
//             {template?.value !== "2" && (
//               <Row className="bg-white px-2 py-4 shadow mb-3">
//                 <h5 className="mb-3">Provider Information</h5>

//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Assigned</label>
//                   <Select
//                     placeholder="Select Status"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={assign_option}
//                     value={assign}
//                     onChange={(e) => onStaffDetail(e)}
//                   />
//                 </div>
//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Contact Person</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Contact Person"
//                     className="form-control "
//                     value={provider_person}
//                     onChange={(e) => setProviderPerson(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Contact</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Contact"
//                     className="form-control "
//                     value={provider_phone}
//                     onChange={(e) => setProviderPhone(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Email Id</label>
//                   <input
//                     type="email"
//                     defaultValue="gia@zithas.com"
//                     placeholder="Enter Email Id"
//                     className="form-control "
//                     value={provider_email}
//                     onChange={(e) => setProviderEmail(e.target.value)}
//                   />
//                 </div>

//                 <div className="col-md-4 mt-2 mt-3 ">
//                   <label htmlFor="">Company Name</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Company Name"
//                     className="form-control "
//                     value={provider_company}
//                     onChange={(e) => setProviderCompany(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-4 mt-2 mt-3 ">
//                   <label htmlFor="">Address</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Address"
//                     className="form-control "
//                     value={provider_address}
//                     onChange={(e) => setProviderAddress(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-4 mt-2 mt-3 ">
//                   <label htmlFor="">Website</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Website"
//                     className="form-control "
//                     value={provider_website}
//                     onChange={(e) => setProviderWebsite(e.target.value)}
//                   />
//                 </div>
//               </Row>
//             )}

//             {/* Deliverables & testing info */}
//             {template?.value !== "2" && (
//               <Row className="bg-white px-2 py-4 shadow mb-3">
//                 <div className="d-flex justify-content-between">
//                   <h5 className="mb-3">Deliverables & testing</h5>
//                   <a
//                     onClick={() => onAddTestingRow()}
//                     className="btn btn-purple btn-label"
//                   >
//                     <i className="fas fa-plus me-2 icon-size label-icon"></i>{" "}
//                     Add New Row
//                   </a>
//                 </div>
//                 <div className="responsive-table">
//                   <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                     <thead className="">
//                       <tr>
//                         <th>Sr No.</th>
//                         <th>Milestone Description</th>
//                         <th>Estimated Time (In Weeks)</th>
//                         <th className="text-center">Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {(testingRows || []).map((testingRow, key) => {
//                         return (
//                           <tr key={key}>
//                             <td className="col-1">
//                               <input
//                                 type="number"
//                                 value={testingRow["sr.no"]}
//                                 className="form-control "
//                                 onChange={(e) => testingSr(e, key)}
//                                 name="sr.no"
//                               />
//                             </td>
//                             <td className="col-7">
//                               <input
//                                 type="text"
//                                 value={testingRow.milestone}
//                                 placeholder="Enter Description"
//                                 className="form-control "
//                                 onChange={(e) => testingMilestone(e, key)}
//                                 name="milestone"
//                               />
//                             </td>
//                             <td className="col-3">
//                               <input
//                                 type="text"
//                                 value={testingRow.estimatedtime}
//                                 placeholder="Enter Estimated Time"
//                                 className="form-control "
//                                 onChange={(e) => testingTime(e, key)}
//                                 name="estimatedtime"
//                               />
//                             </td>
//                             <td className="col-1 text-center">
//                               {key !== 0 ? (
//                                 <a
//                                   onClick={() => onDeleteTestingRow(key)}
//                                   className="btn btn-outline-danger"
//                                 >
//                                   <i className="fas fa-trash-alt"></i>
//                                 </a>
//                               ) : (
//                                 "--"
//                               )}
//                             </td>
//                           </tr>
//                         );
//                       })}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Row>
//             )}

//             {/* Terms and agreement */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Terms and agreement</h5>
//                 <a
//                   onClick={() => onAddTermsRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Particular</th>
//                       <th>Currency</th>
//                       <th>Total</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(termsRows || []).map((termsRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={termsRow.no}
//                               onChange={(e) => termsSr(e, key)}
//                               name="no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={termsRow.service}
//                               onChange={(e) => termsService(e, key)}
//                               name="service"
//                             />
//                           </td>
//                           <td className="col-1">
//                             <input
//                               type="text"
//                               className="form-control "
//                               value={currency?.symbol}
//                               // onChange={e => onCurrency(e, key)}
//                               // value={termsRow.currency}
//                               // onChange={e => termsCurrency(e, key)}
//                               name="currency"
//                               readOnly
//                             />
//                           </td>
//                           <td className="col-2">
//                             <input
//                               type="text"
//                               placeholder={
//                                 key == 0 ? "Estimated Time" : "Enter Total Cost"
//                               }
//                               className="form-control "
//                               value={termsRow.value ?? termsRow.total ?? ""}
//                               onChange={(e) => termsValue(e, key)}
//                               name="value"
//                               style={
//                                 key === 2 ? { backgroundColor: "#f8f6ff" } : {}
//                               }
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key >= 1 ? (
//                               <a
//                                 onClick={() => onDeleteTermsRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* <Row className="bg-white px-2 py-4 shadow mb-3">
//   <div className="d-flex justify-content-between align-items-center mb-3">
//     <h5 className="mb-0">Project Objective</h5>
//   </div>
//   <div className="col-md-12">
//     <textarea
//       className="form-control"
//       rows={6}
//       placeholder="Enter project objective..."
//       value={project_objective}
//       onChange={(e) => setProjectObjective(e.target.value)}
//     />
//   </div>
// </Row> */}

//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="mb-0">Project Objective</h5>
//                 <button
//                   type="button"
//                   className="btn btn-purple btn-label"
//                   onClick={generateObjective}
//                   disabled={isGeneratingObjective}
//                 >
//                   <i
//                     className={`fas ${
//                       isGeneratingObjective ? "fa-spinner fa-spin" : "fa-magic"
//                     } me-2 label-icon`}
//                   ></i>
//                   {isGeneratingObjective ? "Generating..." : "Generate with AI"}
//                 </button>
//               </div>
//               <div className="col-md-12">
//                 <textarea
//                   className="form-control"
//                   rows={6}
//                   placeholder="AI-generated project objective will appear here. Click 'Generate with AI' or type manually."
//                   value={project_objective}
//                   onChange={(e) => setProjectObjective(e.target.value)}
//                 />
//               </div>
//             </Row>

//             {/* Cost Breakdown info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Cost Breakdown</h5>
//                 <a
//                   onClick={() => onAddBreakdownRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Description</th>
//                       <th>Estimated Time (In Hours)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(breakdownRows || []).map((breakdownRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={breakdownRow.sr_no}
//                               onChange={(e) => breakSr(e, key)}
//                               name="sr_no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={breakdownRow.description}
//                               onChange={(e) => breakDescription(e, key)}
//                               name="description"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               value={breakdownRow.totalcost}
//                               onChange={(e) => breakTotal(e, key)}
//                               name="totalcost"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteBreakdownRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* ── Project Timeline ── */}
//             {template?.value !== "2" && (
//               <Row className="bg-white px-2 py-4 shadow mb-3">
//                 <div className="d-flex justify-content-between mb-3">
//                   <h5 className="mb-0">Project Timeline</h5>
//                   <a
//                     onClick={() =>
//                       setTimelineRows([
//                         ...timelineRows,
//                         { phase: "", duration: "", deliverables: "" },
//                       ])
//                     }
//                     className="btn btn-purple btn-label"
//                   >
//                     <i className="fas fa-plus me-2 icon-size label-icon"></i>
//                     Add New Row
//                   </a>
//                 </div>
//                 <div className="responsive-table">
//                   <Table className="table table-bordered mb-0 mt-2">
//                     <thead>
//                       <tr>
//                         <th style={{ color: "#fff", width: "5%" }}>Sr No.</th>
//                         <th style={{ color: "#fff", width: "22%" }}>Phase</th>
//                         <th style={{ color: "#fff", width: "10%" }}>
//                           Duration
//                         </th>
//                         <th style={{ color: "#fff" }}>Key Deliverables</th>
//                         <th
//                           style={{ color: "#fff", width: "8%" }}
//                           className="text-center"
//                         >
//                           Action
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {timelineRows.map((row, key) => (
//                         <tr key={key}>
//                           <td className="text-center align-middle">
//                             {key + 1}
//                           </td>
//                           <td>
//                             <input
//                               type="text"
//                               className="form-control"
//                               placeholder="Enter Phase"
//                               name="phase"
//                               value={row.phase}
//                               onChange={(e) => onTimelineChange(e, key)}
//                             />
//                           </td>
//                           <td>
//                             <input
//                               type="text"
//                               className="form-control"
//                               placeholder="e.g. 1 or 2–3"
//                               name="duration"
//                               value={row.duration}
//                               onChange={(e) => onTimelineChange(e, key)}
//                             />
//                           </td>
//                           <td>
//                             <input
//                               type="text"
//                               className="form-control"
//                               placeholder="Enter key deliverables"
//                               name="deliverables"
//                               value={row.deliverables}
//                               onChange={(e) => onTimelineChange(e, key)}
//                             />
//                           </td>
//                           <td className="text-center align-middle">
//                               <a
//                                 onClick={() => {
//                                   const updated = [...timelineRows];
//                                   updated.splice(key, 1);
//                                   setTimelineRows(updated);
//                                 }}
//                                 className="btn btn-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </div>
//               </Row>
//             )}

//             {/* Conclusion*/}
//             {template?.value !== "2" && (
//               <Row className="bg-white px-2 py-4 shadow mb-3">
//                 <h5 className="mb-3">Conclusion</h5>

//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Email Id</label>
//                   <input
//                     type="email"
//                     placeholder="Enter Email Id"
//                     className="form-control "
//                     value={conclusion_email}
//                     onChange={(e) => setConclusionEmail(e.target.value)}
//                   />
//                 </div>
//                 <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                   <label htmlFor="">Phone Number</label>
//                   <input
//                     type="text"
//                     value={conclusion_phone}
//                     onChange={(e) => setConclusionPhone(e.target.value)}
//                     placeholder="Enter Phone no."
//                     className="form-control "
//                   />
//                 </div>
//               </Row>
//             )}
//           </Form>
//         </Row>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Profile;



// import React, { useState, useEffect } from "react";
// import { Table } from "reactstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import { Row, Form } from "reactstrap";
// import Select from "react-select";
// import Loader from "pages/Separate/Loader";
// import axios from "axios";
// import indiaFlag from "../../../../assets/images/flags/india.png";
// import UkFlag from "../../../../assets/images/flags/uk.png";
// import configure from "configure";

// const Profile = () => {
//   const [fixButtons, setFixButtons] = useState(false);
//   const [testingRows, setTestingRows] = useState([{}]);
//   const [breakdownRows, setBreakdownRows] = useState([{}]);
//   const [termsRows, setTermsRows] = useState([
//     { no: "1", service: "Project duration", currency: "£", total: "" },
//     { no: "2", service: "(Service Name)", currency: "£", total: "" },
//     { no: "3", service: "Domain, Hosting, and SSL (Annual Charges)", currency: "£", total: "" },
//   ]);

//   // For Client information
//   const [client, setClient] = useState([]);

//   // for Provider Informtaion
//   const [providerInfo, setProviderInfo] = useState({});
//   const [relatedClient, setRelatedClient] = useState([]);

//   const navigate = useNavigate();

//   useEffect(() => {
//     setLocation("India");
//     setProviderInfo(ukProvider);

//     setClient(introducer);
//   }, []);



//   // document.title = "Add General Proposal | Zithas Crm"

//   // dynamic Testing form add-remove
//   const onAddTestingRow = () => {
//     setTestingRows([
//       ...testingRows,
//       { "sr.no": testingRows.length + 1, milestone: "", estimatedtime: "" },
//     ]);
//   };

//   const onDeleteTestingRow = (index) => {
//     const newInputs = [...testingRows];
//     newInputs.splice(index, 1);
//     setTestingRows(newInputs);
//   };

//   // dynamic breakdownRows Form add-remove
//   const onAddBreakdownRow = () => {
//     setBreakdownRows([
//       ...breakdownRows,
//       { sr_no: breakdownRows.length + 1, description: "", totalcost: "" },
//     ]);
//   };

//   const onDeleteBreakdownRow = (index) => {
//     const newInputs = [...breakdownRows];
//     newInputs.splice(index, 1);
//     setBreakdownRows(newInputs);
//   };

//   // dynamic Terms and agreement Form add-remove

//   // const onAddTermsRow = () => {
//   //   setTermsRows([
//   //     ...termsRows,
//   //     { no: termsRows.length + 1, service: "", value: "" },
//   //   ]);
//   // };
//   const onAddTermsRow = () => {
//   setTermsRows(prev => [
//     ...prev,
//     { no: prev.length + 1, service: "", currency: "", total: "" },
//   ]);
// };

//   const onDeleteTermsRow = (index) => {
//     const newInputs = [...termsRows];
//     newInputs.splice(index, 1);
//     setTermsRows(newInputs);
//   };

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 160) {
//       setFixButtons(true);
//     } else {
//       setFixButtons(false);
//     }
//   });

//   const colourStyles = {
//     menuList: (styles) => ({
//       ...styles,
//       background: "white",
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 50,
//     }),
//   };

//   // for select controls

//   const related_option = [
//     { label: "Lead", value: "lead" },
//     { label: "Customer", value: "customer" },
//     { label: "Introducer", value: "introducer" },
//   ];
//   // ------------------------

//   // Clients
//   const introducer = [
//     { label: "Nothing Selected", value: "1" },
//     { label: "Jack Smith", value: "2" },
//     { label: "Test company", value: "3" },
//     { label: "Zenith Tins", value: "4" },
//     { label: "Julius Gohil", value: "5" },
//     { label: "Test Introducer", value: "6" },
//   ];

//   const ukProvider = {
//     companyName: "Zithas Technologies",
//     address: "Bristol, United Kingdom",
//     website: "https://www.zithas.co.uk",
//   };

//   //   All Use States
//   const [isLoading, setLoading] = useState([]);
//   const [location_option, setLocationOption] = useState([]);
//   const [status_option, setStatusOption] = useState([]);
//   const [assign_option, setAssignOption] = useState([]);
//   const [currency_option, setCurrencyOption] = useState([]);
//   const [location, setLocation] = useState([]);
//   const [proposal_title, setProposalTitle] = useState("");
//   const [proposal_subtitle, setProposalSubTitle] = useState("");
//   const [status, setStatus] = useState([]);
//   const [currency, setCurrency] = useState([]);
//   const [date, setDate] = useState("");
//   const [till_date, setTillDate] = useState("");
//   const [related, setRelated] = useState([]);
//   const [lead_option, setLeadOption] = useState([]);
//   const [company_name, setCompany_name] = useState("");
//   const [address, setAddress] = useState("");
//   const [website, setWebsite] = useState("");
//   const [person_name, setPersonName] = useState("");
//   const [person_email, setPersonEmail] = useState("");
//   const [person_phone, setPersonPhone] = useState("");
//   const [provider_company, setProviderCompany] = useState("");
//   const [provider_address, setProviderAddress] = useState("");
//   const [provider_website, setProviderWebsite] = useState("");
//   const [provider_person, setProviderPerson] = useState("");
//   const [provider_phone, setProviderPhone] = useState("");
//   const [provider_email, setProviderEmail] = useState("");
//   const [assign, setAssign] = useState([]);
//   const [conclusion_email, setConclusionEmail] = useState("");
//   const [conclusion_phone, setConclusionPhone] = useState("");
//   const [source_id, setSourceId] = useState("");
//   const [contact_name_options, setContactPersionOptions] = useState([]);
//   const [allIntroducers, setIntroducerOption] = useState([]);
//   const [introducerId, setIntroducerId] = useState([]);

//   //   show Proposal Data api Fetch

//   const params = useParams();

//   useEffect(() => {
//     FetchProposalData();
//   }, []);

//   const FetchProposalData = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("proposal_id", params.id);

//     try {
//       // ✅ Run proposal fetch + all dropdown APIs in parallel
//       const [response, curRes, statusRes] = await Promise.all([
//         axios({
//           method: "post",
//           url: `${configure.nodeApi}/view_proposal`,
//           data: formData,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }),
//         axios.get(`${configure.nodeApi}/currency`, {
//           headers: { Accept: "application/json" },
//         }),
//         axios.get(`${configure.apiUrl}/proposal_status`, {
//           headers: { Accept: "application/json" },
//         }),
//       ]);

//       // ✅ Set currency options regardless of proposal data
//       const curOptions = curRes.data.data.currency.map((item) => ({
//         label: item.currency,
//         value: item.id,
//         symbol: item.symbol,
//       }));
//       setCurrencyOption(curOptions);

//       // ✅ Set status options regardless of proposal data
//       const statusOptions = statusRes.data.data.map((obj) => ({
//         value: obj.id,
//         label: obj.name,
//       }));
//       setStatusOption(statusOptions);

//       const d = response.data.data[0];
//       console.log("RAW proposal data:", d);

//       // ✅ Set simple text fields safely
//       if (d.proposaltitile && d.proposaltitile !== "null")
//         setProposalTitle(d.proposaltitile);
//       if (d.proposalsubtitle && d.proposalsubtitle !== "null")
//         setProposalSubTitle(d.proposalsubtitle);
//       if (d.date) setDate(d.date);
//       if (d.opentill) setTillDate(d.opentill);
//       if (d.companyname) setCompany_name(d.companyname);
//       if (d.address && d.address !== "null") setAddress(d.address);
//       if (d.cilentcontact && d.cilentcontact !== "null")
//         setPersonPhone(d.cilentcontact);
//       if (d.email && d.email !== "null") setPersonEmail(d.email);
//       if (d.website && d.website !== "null") setWebsite(d.website);
//       if (d.contactmember) setProviderPerson(d.contactmember);
//       if (d.contact) setProviderPhone(d.contact);
//       if (d.provideremail) setProviderEmail(d.provideremail);
//       if (d.company2) setProviderCompany(d.company2);
//       if (d.address1) setProviderAddress(d.address1);
//       if (d.website1 && d.website1 !== "null") setProviderWebsite(d.website1);
//       if (d.conclusion_email && d.conclusion_email !== "null")
//         setConclusionEmail(d.conclusion_email);
//       if (d.conclusion_contact && d.conclusion_contact !== "null")
//         setConclusionPhone(d.conclusion_contact);

//       try {
//         setTestingRows(JSON.parse(d.deliverytesting) || [{}]);
//       } catch {
//         setTestingRows([{}]);
//       }
//       try {
//         //setTermsRows(JSON.parse(d.terms) || [{}]);
//         const parsedTerms = JSON.parse(d.terms);
//         setTermsRows(parsedTerms?.length > 0 ? parsedTerms : termsRows);
//       } catch {
//         setTermsRows([{}]);
//       }
//       try {
//         setBreakdownRows(JSON.parse(d.costbreakdown) || [{}]);
//       } catch {
//         setBreakdownRows([{}]);
//       }

//       // ✅ Match dropdowns with proposal data
//       setCurrency(curOptions.find((obj) => obj.value == d.currency_id) || null);
//       setStatus(statusOptions.find((obj) => obj.value == d.status) || null);
//       setRelated(related_option.find((obj) => obj.value === d.related) || null);

//       // ✅ location — use fallback if null
//       const locationId = d.location || 1;
//       setLocation(locationId);

//       // ✅ lead_belong for assignee + introducer options (always call regardless)
//       const belongForm = new FormData();
//       belongForm.append("country_id", locationId);
//       const belongRes = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: belongForm,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const assignOptions =
//         belongRes.data.data.assigned?.map((item) => ({
//           value: item.id,
//           label: item.name,
//         })) || [];
//       setAssignOption(assignOptions);
//       // setAssign(assignOptions.find(obj => obj.value == d.assignd) || null)

//       const matchedAssign =
//         assignOptions.find((obj) => obj.value == d.assignd) || null;
//       setAssign(matchedAssign);
//       if (matchedAssign) await fetchStaffDetail(matchedAssign); // ✅ auto-fill

//       const introducerOptions =
//         belongRes.data.data.introducer?.map((obj) => ({
//           label: obj.company,
//           value: obj.id,
//         })) || [];
//       setIntroducerOption(introducerOptions);
//       setIntroducerId(
//         introducerOptions.find((obj) => obj.value == d.introducer_id) || null,
//       );

//       // ✅ related clients — only call if related is set
//       if (d.related) {
//         const relatedForm = new FormData();
//         relatedForm.append("related", d.related);
//         relatedForm.append("location", locationId);
//         const relatedRes = await axios({
//           method: "post",
//           url: `${configure.nodeApi}/related`,
//           data: relatedForm,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         let leadOptions = [];
//         if (d.related === "introducer") {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         } else {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: `${obj.company || "N/A"} - ${
//               obj.person_details?.[0]?.person_name || "NA"
//             } - ${obj.id}`,
//             companyName: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         }
//         setLeadOption(leadOptions);

//         const selectedSource =
//           leadOptions.find((obj) => obj.value == d.source_name) || null;
//         setSourceId(selectedSource);
//         if (selectedSource?.companyName)
//           setCompany_name(selectedSource.companyName);

//         if (selectedSource?.details) {
//           const contactOptions = selectedSource.details.map((person) => ({
//             label: person.person_name,
//             value: person,
//           }));
//           setContactPersionOptions(contactOptions);
//           setPersonName(
//             contactOptions.find((item) => item.label === d.contactname) || null,
//           );
//         } else {
//           setPersonName(d.contactname || "");
//         }
//       }
//     } catch (err) {
//       console.error("FetchProposalData error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onChangeCountry = async (e) => {
//     if (e.value == 1) {
//       setProviderCompany("Zithas Technologies.pvt.ltd");
//       // setProviderAddress("Gotri, Vadodara, Gujarat, India")
//       setProviderWebsite("www.zithas.com");
//     } else if (e.value == 2) {
//       setProviderCompany("Zithas Technologies");
//       // setProviderAddress("Bristol, United Kingdom")
//       setProviderWebsite("www.zithas.co.uk");
//     }

//     setLoading(true);
//     setLocation(e.target.value);
//     const fromData = new FormData();
//     fromData.append("country_id", e.target.value);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setAssignOption(
//           res.data.data.assigned?.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setStatusOption(
//           res.data.data.lead_status.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setLoading(false);
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onChangeRelated = async (e) => {
//     console.log(e);
//     setRelated(e);
//     setRelatedClient(e);
//     setLoading(true);
//     setPersonEmail("");
//     setPersonName("");
//     setPersonPhone("");
//     setSourceId([]);
//     setCompany_name("");
//     setWebsite("");
//     setAddress("");
//     const fromData = new FormData();
//     fromData.append("related", e.value);
//     fromData.append("location", location);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.nodeApi}/related`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);

//         // console.log("Related", res)

//         if (res.data.success === true) {
//           if (e.value == "introducer") {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           } else {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label:
//                   obj.company +
//                   " - " +
//                   (obj.person_details[0]
//                     ? obj.person_details[0]?.person_name
//                     : "NA") +
//                   " - " +
//                   obj?.id,
//                 companyName: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           }
//         }
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onClientInfo = (e) => {
//     setSourceId(e);
//     setCompany_name(e?.companyName);

//     if (related?.value == "lead") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );
//       // setPersonEmail(e.details[0]?.person_email)
//       // setPersonName(e.details[0]?.person_name)
//       // setPersonPhone(e.person_phone)
//       setAddress(e.address);
//       setWebsite(e.website);
//     } else if (related?.value == "customer") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );

//       setPersonEmail(e.details[0]?.email);
//       // setPersonName(e.details[0]?.person_name)
//       setPersonPhone(e.details[0]?.phone);
//       setAddress(e.address);
//       setWebsite(e.website);
//     }
//   };

//   const fetchStaffDetail = async (staffOption) => {
//     if (!staffOption) return;
//     try {
//       const res = await axios.get(
//         `${configure.apiUrl}/show/${staffOption.value}`,
//         {
//           headers: { Accept: "application/json" },
//         },
//       );
//       const staff = res.data.data.staff;
//       setProviderPerson(staffOption.label);
//       setProviderPhone(staff.contact_number || "");
//       setProviderEmail(staff.email || "");
//       setProviderAddress(
//         `${staff.ctname || "-"}, ${staff.sname || "-"}, ${staff.cname || "-"}`,
//       );
//     } catch (err) {
//       console.error("fetchStaffDetail error:", err);
//     }
//   };

//   const onStaffDetail = async (e) => {
//     setAssign(e);
//     setLoading(true);
//     await fetchStaffDetail(e);
//     setLoading(false);
//   };

//   // const onStaffDetail = async e => {
//   //   setProviderPerson(e.label)
//   //   setAssign(e)
//   //   setLoading(true)
//   //   try {
//   //     const response = await axios({
//   //       method: "get",
//   //       url: `${configure.apiUrl}/show/${e.value}`,
//   //       headers: {
//   //         Accept: "application/json",
//   //         "Content-Type": "multipart/form-data",
//   //       },
//   //     }).then(response => {
//   //       setProviderPhone(response.data.data.staff.contact_number)
//   //       setProviderEmail(response.data.data.staff.email)

//   //       let city, state, country

//   //       Object.keys(response.data.data.staff).forEach(obj => {
//   //         switch (obj) {
//   //           case "ctname":
//   //             city =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //           case "sname":
//   //             state =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //           case "cname":
//   //             country =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //         }
//   //       })

//   //       setProviderAddress(`${city}, ${state}, ${country}`)

//   //       setLoading(false)
//   //     })
//   //   } catch (err) {
//   //     console.log(err)
//   //     setLoading(false)
//   //   }
//   // }

//   // Testing Rows on Change Event
//   const testingSr = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingMilestone = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingTime = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };

//   // Terms and Aggrement on Change Event

//   const termsSr = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsService = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsCurrency = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsValue = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };

//   // Cost BreakDown on Change Event

//   const breakDescription = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakSr = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakTotal = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };

//   const onEditProposal = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("proposal_id", params.id);
//     formData.append("proposaltitle", proposal_title);
//     formData.append("proposalsubtitle", proposal_subtitle);
//     formData.append("currency", currency?.value);
//     formData.append("date", date);
//     formData.append("opentill", till_date);
//     formData.append("related", related?.value);
//     formData.append("companyname", company_name);
//     formData.append(
//       "contactname",
//       person_name?.label ? person_name?.label : person_name,
//     );
//     formData.append("address", address);
//     formData.append("clientcontact", person_phone);
//     formData.append("email", person_email);
//     formData.append("website", website);
//     formData.append("assigned", assign?.value);
//     formData.append("company2", provider_company);
//     formData.append("contactnumber", provider_phone);
//     formData.append("address1", provider_address);
//     formData.append("providermail", provider_email);
//     formData.append("contact_member", provider_person);
//     formData.append("website1", provider_website);
//     formData.append("deliverytesting", JSON.stringify(testingRows));
//     formData.append("terms", JSON.stringify(termsRows));
//     formData.append("costbreakdown", JSON.stringify(breakdownRows));
//     formData.append("location", location);
//     formData.append("status", status?.value);
//     formData.append("conclusion_email", conclusion_email);
//     formData.append("conclusion_contact", conclusion_phone);
//     formData.append("source_name", source_id?.value);
//     formData.append("type", "General");
//     formData.append("introducer_id", introducerId?.value);
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.nodeApi}/edit_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);
//         swal({
//           icon: "success",
//           text: "Proposal Edited Succesfully",
//         }).then((data) => {
//           navigate(`${configure.appUrl}sales/proposal`);
//         });
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onCurrency = (e, key) => {
//     let values = [...termsRows];
//     values[key][e.target.name] = e.target.value;
//     setTermsRow(values);
//   };

//     useEffect(() => {
//   if (currency?.symbol) {
//     setTermsRows(prev =>
//       prev.map(row => ({ ...row, currency: currency.symbol }))
//     );
//   }
// }, [currency]);

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="ps-2">
//         <Row className="px-1">
//           <Form onSubmit={onEditProposal}>
//             {/* Fixed Buttons */}
//             <div
//               className={`flex-column fixed-buttons pt-2 ${
//                 fixButtons ? "d-flex" : "d-none"
//               }`}
//             >
//               <button className="btn btn-save btn-label pe-0  fix-btn">
//                 <i className="fas fa-save me-2 label-icon"></i>
//                 <span>Save</span>
//               </button>
//               <a
//                 onClick={() => navigate(-1)}
//                 className="btn btn-red  fix-btn btn-label pe-0"
//               >
//                 <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                 <span>Cancel</span>
//               </a>
//             </div>
//             <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-3 mb-md-0 mb-3">
//                 <label htmlFor="">Introducer</label>
//                 <Select
//                   placeholder="Select Introducer"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={allIntroducers}
//                   value={introducerId}
//                   onChange={(e) => setIntroducerId(e)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3"></div>
//               <div className="col-md-6 mb-3 text-end">
//                 <button className=" btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(-1);
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row>

//             {/* Service  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Service Information</h5>

//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Title</label>
//                 <input
//                   type="text"
//                   defaultValue="Software Development"
//                   placeholder="Enter Proposal Title"
//                   className="form-control "
//                   value={proposal_title}
//                   onChange={(e) => {
//                     setProposalTitle(e.target.value);
//                     // let values = [...termsRows];
//                     // values[1]["service"] = e.target.value;
//                     // setTermsRows(values);
//                     setTermsRows(prev => {
//     if (!prev[1]) return prev; // guard: row index 1 must exist
//     return prev.map((row, i) =>
//       i === 1 ? { ...row, service: e.target.value } : row
//     );
//   });
//                   }}
//                 />
//               </div>
//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Subtitle</label>
//                 <input
//                   type="text"
//                   defaultValue="Zithas Mars - Payroll Management"
//                   placeholder="Enter Proposal Subtitle"
//                   className="form-control "
//                   value={proposal_subtitle}
//                   onChange={(e) => setProposalSubTitle(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Status</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={status_option}
//                   value={status}
//                   onChange={(e) => setStatus(e)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Currency</label>
//                 <Select
//                   placeholder="Select Currency"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={currency_option}
//                   value={currency}
//                   onChange={(e) => setCurrency(e)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Date</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Open Till</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={till_date}
//                   onChange={(e) => setTillDate(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Related </label>
//                 <Select
//                   placeholder="Select"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={related_option}
//                   value={related}
//                   onChange={(e) => onChangeRelated(e)}
//                 />
//               </div>
//             </Row>

//             {/* Client  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Client Information</h5>

//               {related?.label !== "Nothing Selected" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">{related?.label}</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={lead_option}
//                     value={source_id}
//                     onChange={(e) => onClientInfo(e)}
//                   />
//                 </div>
//               ) : null}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={company_name}
//                   onChange={(e) => setCompany_name(e.target.value)}
//                 />
//               </div>
//               {/* <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={person_name}
//                   onChange={e => setPersonName(e.target.value)}
//                 />
//               </div> */}

//               {related?.label == "Introducer" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Contact Person"
//                     className="form-control "
//                     value={person_name}
//                     onChange={(e) => setPersonName(e.target.value)}
//                   />
//                 </div>
//               ) : (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={contact_name_options}
//                     value={person_name}
//                     onChange={(e) => {
//                       setPersonName(e);
//                       console.log(e);
//                       setPersonEmail(e?.value.person_email);
//                       setPersonPhone(e?.value.person_phone);
//                     }}
//                   />
//                 </div>
//               )}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="number"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={person_phone}
//                   onChange={(e) => setPersonPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={person_email}
//                   onChange={(e) => setPersonEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Website</label>

//                 <input
//                   type="text"
//                   placeholder="Enter URL"
//                   className="form-control "
//                   value={website}
//                   onChange={(e) => setWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>

//             {/* Provider  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Provider Information</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Assigned</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={assign_option}
//                   value={assign}
//                   onChange={(e) => onStaffDetail(e)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={provider_person}
//                   onChange={(e) => setProviderPerson(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={provider_phone}
//                   onChange={(e) => setProviderPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   defaultValue="gia@zithas.com"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={provider_email}
//                   onChange={(e) => setProviderEmail(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={provider_company}
//                   onChange={(e) => setProviderCompany(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={provider_address}
//                   onChange={(e) => setProviderAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Website</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Website"
//                   className="form-control "
//                   value={provider_website}
//                   onChange={(e) => setProviderWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>

//             {/* Deliverables & testing info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Deliverables & testing</h5>
//                 <a
//                   onClick={() => onAddTestingRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Milestone Description</th>
//                       <th>Estimated Time (In Weeks)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(testingRows || []).map((testingRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               value={testingRow["sr.no"]}
//                               className="form-control "
//                               onChange={(e) => testingSr(e, key)}
//                               name="sr.no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               value={testingRow.milestone}
//                               placeholder="Enter Description"
//                               className="form-control "
//                               onChange={(e) => testingMilestone(e, key)}
//                               name="milestone"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               value={testingRow.estimatedtime}
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               onChange={(e) => testingTime(e, key)}
//                               name="estimatedtime"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteTestingRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Terms and agreement */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Terms and agreement</h5>
//                 <a
//                   onClick={() => onAddTermsRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Particular</th>
//                       <th>Currency</th>
//                       <th>Total</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(termsRows || []).map((termsRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={termsRow.no}
//                               onChange={(e) => termsSr(e, key)}
//                               name="no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={termsRow.service}
//                               onChange={(e) => termsService(e, key)}
//                               name="service"
//                             />
//                           </td>
//                           <td className="col-1">
//                             <input
//                               type="text"
//                               className="form-control "
//                               value={currency?.symbol}
//                               name="currency"
//                               readOnly
//                             />
//                           </td>
//                           <td className="col-2">
//                             <input
//                               type="text"
//                               placeholder={
//                                 key == 0 ? "Estimated Time" : "Enter Total Cost"
//                               }
//                               className="form-control "
//                               value={termsRow.total}
//                               onChange={(e) => termsValue(e, key)}
//                               name="total"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key >= 1 ? (
//                               <a
//                                 onClick={() => onDeleteTermsRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Cost Breakdown info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Cost Breakdown</h5>
//                 <a
//                   onClick={() => onAddBreakdownRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Description</th>
//                       <th>Estimated Time (In Weeks)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(breakdownRows || []).map((breakdownRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={breakdownRow.sr_no}
//                               onChange={(e) => breakSr(e, key)}
//                               name="sr_no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={breakdownRow.description}
//                               onChange={(e) => breakDescription(e, key)}
//                               name="description"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               value={breakdownRow.totalcost}
//                               onChange={(e) => breakTotal(e, key)}
//                               name="totalcost"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteBreakdownRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Conclusion*/}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Conclusion</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={conclusion_email}
//                   onChange={(e) => setConclusionEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Phone Number</label>
//                 <input
//                   type="text"
//                   value={conclusion_phone}
//                   onChange={(e) => setConclusionPhone(e.target.value)}
//                   placeholder="Enter Phone no."
//                   className="form-control "
//                 />
//               </div>
//             </Row>
//           </Form>
//         </Row>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Profile;




// import React, { useState, useEffect } from "react";
// import { Table } from "reactstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import { Row, Form } from "reactstrap";
// import Select from "react-select";
// import Loader from "pages/Separate/Loader";
// import axios from "axios";
// import indiaFlag from "../../../../assets/images/flags/india.png";
// import UkFlag from "../../../../assets/images/flags/uk.png";
// import configure from "configure";

// const Profile = () => {
//   const [fixButtons, setFixButtons] = useState(false);
//   const [testingRows, setTestingRows] = useState([{}]);
//   const [breakdownRows, setBreakdownRows] = useState([{}]);
//   // const [termsRows, setTermsRows] = useState([{}]);
//     const [termsRows, setTermsRows] = useState([
//       {
//         no: "1",
//         service: "Project duration",
//         currency: "£",
//         total: "",
//       },
//       {
//         no: "2",
//         service: "(Service Name)",
//         currency: "£",
//         total: "",
//       },
//       {
//         no: "3",
//         service: "Domain, Hosting, and SSL (Annual Charges)",
//         currency: "£",
//         total: "",
//       },
//     ]);

//   // For Client information
//   const [client, setClient] = useState([]);

//   // for Provider Informtaion
//   const [providerInfo, setProviderInfo] = useState({});
//   const [relatedClient, setRelatedClient] = useState([]);

//   const [template, setTemplate] = useState({ value: "1", label: "Template 1" });
//   const template_options = [
//     { label: "Template 1", value: "1" },
//     { label: "Blank Template", value: "2" },
//   ];

//   const FIXED_PHASES = [
//     "Discovery & Strategy",
//     "UI/UX Design",
//     "Development",
//     "Content Integration",
//     "QA & Testing",
//     "Deployment",
//   ];

//   const [timelineRows, setTimelineRows] = useState(
//     FIXED_PHASES.map((phase) => ({ phase, duration: "", deliverables: "" })),
//   );

//   const navigate = useNavigate();

//   useEffect(() => {
//     setLocation("India");
//     setProviderInfo(ukProvider);

//     setClient(introducer);
//   }, []);

//   // document.title = "Add General Proposal | Zithas Crm"

//   // dynamic Testing form add-remove
//   const onAddTestingRow = () => {
//     setTestingRows([
//       ...testingRows,
//       { "sr.no": testingRows.length + 1, milestone: "", estimatedtime: "" },
//     ]);
//   };

//   const onDeleteTestingRow = (index) => {
//     const newInputs = [...testingRows];
//     newInputs.splice(index, 1);
//     setTestingRows(newInputs);
//   };

//   // dynamic breakdownRows Form add-remove
//   const onAddBreakdownRow = () => {
//     setBreakdownRows([
//       ...breakdownRows,
//       { sr_no: breakdownRows.length + 1, description: "", totalcost: "" },
//     ]);
//   };

//   const onDeleteBreakdownRow = (index) => {
//     const newInputs = [...breakdownRows];
//     newInputs.splice(index, 1);
//     setBreakdownRows(newInputs);
//   };

//   // dynamic Terms and agreement Form add-remove
//   // const onAddTermsRow = () => {
//   //   setTermsRows([...termsRows, {}]);
//   // };

//   const onAddTermsRow = () => {
//     setTermsRows([
//       ...termsRows,
//       { no: termsRows.length + 1, service: "", value: "" },
//     ]);
//   };

//   const onDeleteTermsRow = (index) => {
//     const newInputs = [...termsRows];
//     newInputs.splice(index, 1);
//     setTermsRows(newInputs);
//   };

//   const onTimelineChange = (e, key) => {
//     const updated = [...timelineRows];
//     updated[key] = { ...updated[key], [e.target.name]: e.target.value };
//     setTimelineRows(updated);
//   };

//   document.addEventListener("scroll", () => {
//     if (window.scrollY > 160) {
//       setFixButtons(true);
//     } else {
//       setFixButtons(false);
//     }
//   });

//   const colourStyles = {
//     menuList: (styles) => ({
//       ...styles,
//       background: "white",
//     }),
//     menu: (base) => ({
//       ...base,
//       zIndex: 50,
//     }),
//   };

//   // for select controls

//   const related_option = [
//     { label: "Lead", value: "lead" },
//     { label: "Customer", value: "customer" },
//     { label: "Introducer", value: "introducer" },
//   ];
//   // ------------------------

//   // Clients
//   const introducer = [
//     { label: "Nothing Selected", value: "1" },
//     { label: "Jack Smith", value: "2" },
//     { label: "Test company", value: "3" },
//     { label: "Zenith Tins", value: "4" },
//     { label: "Julius Gohil", value: "5" },
//     { label: "Test Introducer", value: "6" },
//   ];

//   const ukProvider = {
//     companyName: "Zithas Technologies",
//     address: "Bristol, United Kingdom",
//     website: "https://www.zithas.co.uk",
//   };

//   //   All Use States
//   const [isLoading, setLoading] = useState([]);
//   const [location_option, setLocationOption] = useState([]);
//   const [status_option, setStatusOption] = useState([]);
//   const [assign_option, setAssignOption] = useState([]);
//   const [currency_option, setCurrencyOption] = useState([]);
//   const [location, setLocation] = useState([]);
//   const [proposal_title, setProposalTitle] = useState("");
//   const [proposal_subtitle, setProposalSubTitle] = useState("");
//   const [status, setStatus] = useState([]);
//   const [currency, setCurrency] = useState([]);
//   const [date, setDate] = useState("");
//   const [till_date, setTillDate] = useState("");
//   const [related, setRelated] = useState([]);
//   const [lead_option, setLeadOption] = useState([]);
//   const [company_name, setCompany_name] = useState("");
//   const [address, setAddress] = useState("");
//   const [website, setWebsite] = useState("");
//   const [person_name, setPersonName] = useState("");
//   const [person_email, setPersonEmail] = useState("");
//   const [person_phone, setPersonPhone] = useState("");
//   const [provider_company, setProviderCompany] = useState("");
//   const [provider_address, setProviderAddress] = useState("");
//   const [provider_website, setProviderWebsite] = useState("");
//   const [provider_person, setProviderPerson] = useState("");
//   const [provider_phone, setProviderPhone] = useState("");
//   const [provider_email, setProviderEmail] = useState("");
//   const [assign, setAssign] = useState([]);
//   const [conclusion_email, setConclusionEmail] = useState("");
//   const [conclusion_phone, setConclusionPhone] = useState("");
//   const [source_id, setSourceId] = useState("");
//   const [contact_name_options, setContactPersionOptions] = useState([]);
//   const [allIntroducers, setIntroducerOption] = useState([]);
//   const [introducerId, setIntroducerId] = useState([]);

//   //   show Proposal Data api Fetch

//   const params = useParams();

//   useEffect(() => {
//     FetchProposalData();
//   }, []);

//   // const FetchProposalData = async () => {
//   //   setLoading(true)
//   //   const formData = new FormData()
//   //   formData.append("proposal_id", params.id)
//   //   try {
//   //     const response = await axios({
//   //       method: "post",
//   //       url: `${configure.nodeApi}/view_proposal`,
//   //       data: formData,
//   //       headers: {
//   //         Accept: "application/json",
//   //         "Content-Type": "multipart/form-data",
//   //       },
//   //     }).then(async response => {
//   //       if (
//   //         response.data.data[0].proposaltitile != "undefined" &&
//   //         response.data.data[0].proposaltitile != "null"
//   //       )
//   //         setProposalTitle(response.data.data[0].proposaltitile)

//   //       if (
//   //         response.data.data[0].proposalsubtitle != "undefined" &&
//   //         response.data.data[0].proposalsubtitle != "null"
//   //       )
//   //         setProposalSubTitle(response.data.data[0].proposalsubtitle)
//   //       setDate(response.data.data[0].date)
//   //       setTillDate(response.data.data[0].opentill)
//   //       const currRelated = related_option.filter(
//   //         obj => obj.value == response.data.data[0].related
//   //       )[0]
//   //       setRelated(currRelated)

//   //       setCompany_name(response.data.data[0].companyname)

//   //       if (
//   //         response.data.data[0].address != "undefined" &&
//   //         response.data.data[0].address != "null"
//   //       )
//   //         setAddress(response.data.data[0].address)

//   //       if (
//   //         response.data.data[0].cilentcontact != "undefined" &&
//   //         response.data.data[0].cilentcontact != "null"
//   //       )
//   //         setPersonPhone(response.data.data[0].cilentcontact)

//   //       if (
//   //         response.data.data[0].email != "undefined" &&
//   //         response.data.data[0].email != "null"
//   //       )
//   //         setPersonEmail(response.data.data[0].email)

//   //       if (
//   //         response.data.data[0].website != "undefined" &&
//   //         response.data.data[0].website != "null"
//   //       )
//   //         setWebsite(response.data.data[0].website)
//   //       setProviderPerson(response.data.data[0].contactmember)
//   //       setProviderPhone(response.data.data[0].contact)
//   //       setProviderEmail(response.data.data[0].provideremail)
//   //       setProviderCompany(response.data.data[0].company2)
//   //       setProviderAddress(response.data.data[0].address1)
//   //       if (
//   //         response.data.data[0].website != "undefined" &&
//   //         response.data.data[0].website != "null"
//   //       )
//   //         setProviderWebsite(response.data.data[0].website1)

//   //       setTestingRows(JSON?.parse(response.data.data[0].deliverytesting) || [{}])
//   //       setTermsRows(JSON?.parse(response.data.data[0].terms) || [{}])
//   //       setBreakdownRows(JSON?.parse(response.data.data[0].costbreakdown) || [{}])

//   //       if (
//   //         response.data.data[0].conclusion_email != "undefined" &&
//   //         response.data.data[0].conclusion_email != "null"
//   //       )
//   //         setConclusionEmail(response.data.data[0].conclusion_email)
//   //       if (
//   //         response.data.data[0].conclusion_contact != "undefined" &&
//   //         response.data.data[0].conclusion_contact != "null"
//   //       )
//   //         setConclusionPhone(response.data.data[0].conclusion_contact)

//   //       await axios({
//   //         method: "get",
//   //         url: `${configure.nodeApi}/locations`,
//   //         headers: {
//   //           Accept: "application/json",
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }).then(res => {
//   //         const option = res?.data.data.map(obj => ({
//   //           label: obj.location,
//   //           value: obj.id,
//   //           link: obj?.Link
//   //         }))
//   //         setLocationOption(option)
//   //         setLocation(response.data.data[0].location)
//   //         setLoading(false)
//   //       })

//   //       await axios({
//   //         method: "get",
//   //         url: `${configure.nodeApi}/currency`,
//   //         headers: {
//   //           Accept: "application/json",
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }).then(res => {
//   //         const option = res.data.data.currency.map(item => ({
//   //           label: item.currency,
//   //           value: item.id,
//   //           symbol: item.symbol,
//   //         }))
//   //         setCurrencyOption(option)
//   //         setCurrency(
//   //           option.filter(
//   //             obj => obj.value == response.data.data[0].currency_id
//   //           )[0]
//   //         )
//   //         setLoading(false)
//   //       })

//   //       await axios({
//   //         method: "get",
//   //         url: `${configure.apiUrl}/proposal_status`,
//   //         headers: {
//   //           Accept: "application/json",
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }).then(res3 => {
//   //         const option = res3.data.data.map(obj => ({
//   //           value: obj.id,
//   //           label: obj.name,
//   //         }))
//   //         setStatusOption(option)
//   //         setStatus(
//   //           option.filter(obj => obj.value == response.data.data[0].status)[0]
//   //         )
//   //       })

//   //       const fromData1 = new FormData()
//   //       fromData1.append("related", response.data.data[0].related)
//   //       fromData1.append("location", response.data.data[0].location)

//   //       await axios({
//   //         method: "post",
//   //         url: `${configure.nodeApi}/related`,
//   //         data: fromData1,
//   //         headers: {
//   //           Accept: "application/json",
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }).then(res2 => {
//   //         setLoading(false)

//   //         let options

//   //         if (response.data.data[0].related == "introducer") {
//   //           options = res2.data.data.map(obj => ({
//   //             value: obj.id,
//   //             label: obj.company,
//   //             address: obj.address,
//   //             details: obj.person_details,
//   //             website: obj.website,
//   //           }))
//   //         } else {
//   //           options = res2.data.data.map(obj => ({
//   //             value: obj.id,
//   //             label:
//   //               obj.company +
//   //               " - " +
//   //               (obj.person_details[0]
//   //                 ? obj.person_details[0]?.person_name
//   //                 : "NA") + " - " + obj?.id,
//   //             companyName: obj.company,
//   //             address: obj.address,
//   //             details: obj.person_details,
//   //             website: obj.website,
//   //           }))
//   //         }

//   //         setLeadOption(options)

//   //         const temp = options.filter(
//   //           obj => obj.value == response.data.data[0].source_name
//   //         )[0]

//   //         // setTimeout(() => onClientInfo(temp), 2000)

//   //         setSourceId(temp)
//   //         setCompany_name(temp?.companyName)
//   //         if (temp?.details) {
//   //           const contact_person_options = temp?.details?.map(person => ({
//   //             label: person.person_name,
//   //             value: person,
//   //           }))
//   //           setContactPersionOptions(contact_person_options)
//   //           setPersonName(
//   //             contact_person_options.find(
//   //               item => item.label == response.data.data[0].contactname
//   //             )
//   //           )
//   //         } else {
//   //           setPersonName(response.data.data[0].contactname)
//   //         }

//   //         // if (currRelated?.value == "lead") {
//   //         //   setPersonName(contact_person_options.find(item => item.label == response.data.data[0].contactname))
//   //         //   setAddress(temp.address)
//   //         //   setWebsite(temp.website)
//   //         // } else if (currRelated?.value == "customer") {
//   //         //   setPersonEmail(temp.details[0]?.email)
//   //         //   // setPersonName(temp.details[0]?.person_name)
//   //         //   setPersonPhone(temp.details[0]?.phone)
//   //         //   setAddress(temp.address)
//   //         //   setWebsite(temp.website)
//   //         // }

//   //         // onClientInfo(temp)
//   //       })

//   //       const fromData = new FormData()
//   //       fromData.append("country_id", response.data.data[0].location)
//   //       await axios({
//   //         method: "post",
//   //         url: `${configure.apiUrl}/lead_belong`,
//   //         data: fromData,
//   //         headers: {
//   //           Accept: "application/json",
//   //           "Content-Type": "multipart/form-data",
//   //         },
//   //       }).then(res => {
//   //         console.log("lead_belong response:", res.data.data)
//   // console.log("introducers:", res?.data?.data?.introducer)
//   //         setAssignOption(
//   //           res.data.data.assigned?.map(item => ({
//   //             value: item.id,
//   //             label: item.name,
//   //           }))
//   //         )
//   //         setAssign(
//   //           res.data.data.assigned
//   //             ?.map(item => ({
//   //               value: item.id,
//   //               label: item.name,
//   //             }))
//   //             .filter(obj => obj.value == response.data.data[0].assignd)[0]
//   //         )
//   //         const introducers = res?.data?.data?.introducer?.map((obj) => ({
//   //           label: obj.company,
//   //           value: obj.id,
//   //         }))
//   //         console.log("mapped introducers:", introducers)
//   //         setIntroducerId(introducers?.find((objs) => objs?.value == response.data.data[0].introducer_id))
//   //         setIntroducerOption(introducers)
//   //         setLoading(false)
//   //       })

//   //       setLoading(false)
//   //     })
//   //   } catch (err) {
//   //     console.log(err)
//   //     setLoading(false)
//   //   }
//   // }

//   //   const FetchProposalData = async () => {
//   //   setLoading(true)
//   //   const formData = new FormData()
//   //   formData.append("proposal_id", params.id)
//   //   try {
//   //     const response = await axios({
//   //       method: "post",
//   //       url: `${configure.nodeApi}/view_proposal`,
//   //       data: formData,
//   //       headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
//   //     })

//   //     const d = response.data.data[0]

//   //     // Set simple fields
//   //     if (d.proposaltitile && d.proposaltitile !== "null") setProposalTitle(d.proposaltitile)
//   //     if (d.proposalsubtitle && d.proposalsubtitle !== "null") setProposalSubTitle(d.proposalsubtitle)
//   //     setDate(d.date)
//   //     setTillDate(d.opentill)
//   //     setCompany_name(d.companyname)
//   //     if (d.address && d.address !== "null") setAddress(d.address)
//   //     if (d.cilentcontact && d.cilentcontact !== "null") setPersonPhone(d.cilentcontact)
//   //     if (d.email && d.email !== "null") setPersonEmail(d.email)
//   //     if (d.website && d.website !== "null") setWebsite(d.website)
//   //     setProviderPerson(d.contactmember)
//   //     setProviderPhone(d.contact)
//   //     setProviderEmail(d.provideremail)
//   //     setProviderCompany(d.company2)
//   //     setProviderAddress(d.address1)
//   //     if (d.website1 && d.website1 !== "null") setProviderWebsite(d.website1)
//   //     setTestingRows(JSON?.parse(d.deliverytesting) || [{}])
//   //     setTermsRows(JSON?.parse(d.terms) || [{}])
//   //     setBreakdownRows(JSON?.parse(d.costbreakdown) || [{}])
//   //     if (d.conclusion_email && d.conclusion_email !== "null") setConclusionEmail(d.conclusion_email)
//   //     if (d.conclusion_contact && d.conclusion_contact !== "null") setConclusionPhone(d.conclusion_contact)

//   //     const currRelated = related_option.find(obj => obj.value === d.related)
//   //     setRelated(currRelated)

//   //     // ✅ Use d.location (the raw ID) directly in all subsequent calls
//   //     const locationId = d.location

//   //     // Locations dropdown
//   //     const locRes = await axios.get(`${configure.nodeApi}/locations`, {
//   //       headers: { Accept: "application/json" },
//   //     })
//   //     const locOptions = locRes.data.data.map(obj => ({
//   //       label: obj.location, value: obj.id, link: obj?.Link
//   //     }))
//   //     setLocationOption(locOptions)
//   //     setLocation(locationId) // ✅ set as the ID number

//   //     // Currency dropdown
//   //     const curRes = await axios.get(`${configure.nodeApi}/currency`, {
//   //       headers: { Accept: "application/json" },
//   //     })
//   //     const curOptions = curRes.data.data.currency.map(item => ({
//   //       label: item.currency, value: item.id, symbol: item.symbol,
//   //     }))
//   //     setCurrencyOption(curOptions)
//   //     // ✅ Use currency_id from response, not currency (which is the symbol)
//   //     setCurrency(curOptions.find(obj => obj.value == d.currency_id) || null)

//   //     // Status dropdown
//   //     const statusRes = await axios.get(`${configure.apiUrl}/proposal_status`, {
//   //       headers: { Accept: "application/json" },
//   //     })
//   //     const statusOptions = statusRes.data.data.map(obj => ({ value: obj.id, label: obj.name }))
//   //     setStatusOption(statusOptions)
//   //     setStatus(statusOptions.find(obj => obj.value == d.status) || null)

//   //     // ✅ Related clients — pass locationId directly, not location state
//   //     const relatedForm = new FormData()
//   //     relatedForm.append("related", d.related)
//   //     relatedForm.append("location", locationId) // ✅ KEY FIX
//   //     const relatedRes = await axios({
//   //       method: "post",
//   //       url: `${configure.nodeApi}/related`,
//   //       data: relatedForm,
//   //       headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
//   //     })

//   //     let leadOptions
//   //     if (d.related === "introducer") {
//   //       leadOptions = relatedRes.data.data.map(obj => ({
//   //         value: obj.id, label: obj.company,
//   //         address: obj.address, details: obj.person_details, website: obj.website,
//   //       }))
//   //     } else {
//   //       leadOptions = relatedRes.data.data.map(obj => ({
//   //         value: obj.id,
//   //         label: obj.company + " - " + (obj.person_details[0]?.person_name || "NA") + " - " + obj.id,
//   //         companyName: obj.company,
//   //         address: obj.address, details: obj.person_details, website: obj.website,
//   //       }))
//   //     }
//   //     setLeadOption(leadOptions)

//   //     // ✅ Find and set the selected source/lead
//   //     const selectedSource = leadOptions.find(obj => obj.value == d.source_name) || null
//   //     setSourceId(selectedSource)
//   //     if (selectedSource?.companyName) setCompany_name(selectedSource.companyName)

//   //     if (selectedSource?.details) {
//   //       const contactOptions = selectedSource.details.map(person => ({
//   //         label: person.person_name, value: person,
//   //       }))
//   //       setContactPersionOptions(contactOptions)
//   //       // ✅ Match by contactname from response
//   //       setPersonName(contactOptions.find(item => item.label === d.contactname) || null)
//   //     } else {
//   //       setPersonName(d.contactname)
//   //     }

//   //     // ✅ lead_belong — pass locationId directly
//   //     const belongForm = new FormData()
//   //     belongForm.append("country_id", locationId) // ✅ KEY FIX
//   //     const belongRes = await axios({
//   //       method: "post",
//   //       url: `${configure.apiUrl}/lead_belong`,
//   //       data: belongForm,
//   //       headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
//   //     })

//   //     const assignOptions = belongRes.data.data.assigned?.map(item => ({
//   //       value: item.id, label: item.name,
//   //     })) || []
//   //     setAssignOption(assignOptions)
//   //     // ✅ Match by assignd from response
//   //     setAssign(assignOptions.find(obj => obj.value == d.assignd) || null)

//   //     const introducerOptions = belongRes.data.data.introducer?.map(obj => ({
//   //       label: obj.company, value: obj.id,
//   //     })) || []
//   //     setIntroducerOption(introducerOptions)
//   //     setIntroducerId(introducerOptions.find(obj => obj.value == d.introducer_id) || null)

//   //     setLoading(false)
//   //   } catch (err) {
//   //     console.log(err)
//   //     setLoading(false)
//   //   }
//   // }

//   const FetchProposalData = async () => {
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("proposal_id", params.id);

//     try {
//       // ✅ Run proposal fetch + all dropdown APIs in parallel
//       const [response, curRes, statusRes] = await Promise.all([
//         axios({
//           method: "post",
//           url: `${configure.nodeApi}/view_proposal`,
//           data: formData,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         }),
//         axios.get(`${configure.nodeApi}/currency`, {
//           headers: { Accept: "application/json" },
//         }),
//         axios.get(`${configure.apiUrl}/proposal_status`, {
//           headers: { Accept: "application/json" },
//         }),
//       ]);

//       // ✅ Set currency options regardless of proposal data
//       const curOptions = curRes.data.data.currency.map((item) => ({
//         label: item.currency,
//         value: item.id,
//         symbol: item.symbol,
//       }));
//       setCurrencyOption(curOptions);

//       // ✅ Set status options regardless of proposal data
//       const statusOptions = statusRes.data.data.map((obj) => ({
//         value: obj.id,
//         label: obj.name,
//       }));
//       setStatusOption(statusOptions);

//       const d = response.data.data[0];
//       console.log("RAW proposal data:", d);

//       // ✅ Set simple text fields safely
//       if (d.proposaltitile && d.proposaltitile !== "null")
//         setProposalTitle(d.proposaltitile);
//       if (d.proposalsubtitle && d.proposalsubtitle !== "null")
//         setProposalSubTitle(d.proposalsubtitle);
//       if (d.date) setDate(d.date);
//       if (d.opentill) setTillDate(d.opentill);
//       if (d.companyname) setCompany_name(d.companyname);
//       if (d.address && d.address !== "null") setAddress(d.address);
//       if (d.cilentcontact && d.cilentcontact !== "null")
//         setPersonPhone(d.cilentcontact);
//       if (d.email && d.email !== "null") setPersonEmail(d.email);
//       if (d.website && d.website !== "null") setWebsite(d.website);
//       if (d.contactmember) setProviderPerson(d.contactmember);
//       if (d.contact) setProviderPhone(d.contact);
//       if (d.provideremail) setProviderEmail(d.provideremail);
//       if (d.company2) setProviderCompany(d.company2);
//       if (d.address1) setProviderAddress(d.address1);
//       if (d.website1 && d.website1 !== "null") setProviderWebsite(d.website1);
//       if (d.conclusion_email && d.conclusion_email !== "null")
//         setConclusionEmail(d.conclusion_email);
//       if (d.conclusion_contact && d.conclusion_contact !== "null")
//         setConclusionPhone(d.conclusion_contact);
//       if (d.template) {
//         setTemplate(
//           template_options.find((o) => o.value == d.template) || {
//             value: "1",
//             label: "Template 1",
//           },
//         );
//       }
//       if (d.timeline) {
//         try {
//           const saved = JSON.parse(d.timeline);
//           setTimelineRows(
//             FIXED_PHASES.map((phase, i) => ({
//               phase,
//               duration: saved[i]?.duration || "",
//               deliverables: saved[i]?.deliverables || "",
//             })),
//           );
//         } catch {
//           // leave defaults
//         }
//       }

//       try {
//         setTestingRows(JSON.parse(d.deliverytesting) || [{}]);
//       } catch {
//         setTestingRows([{}]);
//       }
//       try {
//         setTermsRows(JSON.parse(d.terms) || [{}]);
//       } catch {
//         setTermsRows([{}]);
//       }
//       try {
//         setBreakdownRows(JSON.parse(d.costbreakdown) || [{}]);
//       } catch {
//         setBreakdownRows([{}]);
//       }

//       // ✅ Match dropdowns with proposal data
//       setCurrency(curOptions.find((obj) => obj.value == d.currency_id) || null);
//       setStatus(statusOptions.find((obj) => obj.value == d.status) || null);
//       setRelated(related_option.find((obj) => obj.value === d.related) || null);

//       // ✅ location — use fallback if null
//       const locationId = d.location || 1;
//       setLocation(locationId);

//       // ✅ lead_belong for assignee + introducer options (always call regardless)
//       const belongForm = new FormData();
//       belongForm.append("country_id", locationId);
//       const belongRes = await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: belongForm,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const assignOptions =
//         belongRes.data.data.assigned?.map((item) => ({
//           value: item.id,
//           label: item.name,
//         })) || [];
//       setAssignOption(assignOptions);
//       // setAssign(assignOptions.find(obj => obj.value == d.assignd) || null)

//       const matchedAssign =
//         assignOptions.find((obj) => obj.value == d.assignd) || null;
//       setAssign(matchedAssign);
//       if (matchedAssign) await fetchStaffDetail(matchedAssign); // ✅ auto-fill

//       const introducerOptions =
//         belongRes.data.data.introducer?.map((obj) => ({
//           label: obj.company,
//           value: obj.id,
//         })) || [];
//       setIntroducerOption(introducerOptions);
//       setIntroducerId(
//         introducerOptions.find((obj) => obj.value == d.introducer_id) || null,
//       );

//       // ✅ related clients — only call if related is set
//       if (d.related) {
//         const relatedForm = new FormData();
//         relatedForm.append("related", d.related);
//         relatedForm.append("location", locationId);
//         const relatedRes = await axios({
//           method: "post",
//           url: `${configure.nodeApi}/related`,
//           data: relatedForm,
//           headers: {
//             Accept: "application/json",
//             "Content-Type": "multipart/form-data",
//           },
//         });

//         let leadOptions = [];
//         if (d.related === "introducer") {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         } else {
//           leadOptions = relatedRes.data.data.map((obj) => ({
//             value: obj.id,
//             label: `${obj.company || "N/A"} - ${
//               obj.person_details?.[0]?.person_name || "NA"
//             } - ${obj.id}`,
//             companyName: obj.company,
//             address: obj.address,
//             details: obj.person_details,
//             website: obj.website,
//           }));
//         }
//         setLeadOption(leadOptions);

//         const selectedSource =
//           leadOptions.find((obj) => obj.value == d.source_name) || null;
//         setSourceId(selectedSource);
//         if (selectedSource?.companyName)
//           setCompany_name(selectedSource.companyName);

//         if (selectedSource?.details) {
//           const contactOptions = selectedSource.details.map((person) => ({
//             label: person.person_name,
//             value: person,
//           }));
//           setContactPersionOptions(contactOptions);
//           setPersonName(
//             contactOptions.find((item) => item.label === d.contactname) || null,
//           );
//         } else {
//           setPersonName(d.contactname || "");
//         }
//       }
//     } catch (err) {
//       console.error("FetchProposalData error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const onChangeCountry = async (e) => {
//     if (e.value == 1) {
//       setProviderCompany("Zithas Technologies.pvt.ltd");
//       // setProviderAddress("Gotri, Vadodara, Gujarat, India")
//       setProviderWebsite("www.zithas.com");
//     } else if (e.value == 2) {
//       setProviderCompany("Zithas Technologies");
//       // setProviderAddress("Bristol, United Kingdom")
//       setProviderWebsite("www.zithas.co.uk");
//     }

//     setLoading(true);
//     setLocation(e.target.value);
//     const fromData = new FormData();
//     fromData.append("country_id", e.target.value);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.apiUrl}/lead_belong`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setAssignOption(
//           res.data.data.assigned?.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setStatusOption(
//           res.data.data.lead_status.map((item) => ({
//             value: item.id,
//             label: item.name,
//           })),
//         );
//         setLoading(false);
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onChangeRelated = async (e) => {
//     console.log(e);
//     setRelated(e);
//     setRelatedClient(e);
//     setLoading(true);
//     setPersonEmail("");
//     setPersonName("");
//     setPersonPhone("");
//     setSourceId([]);
//     setCompany_name("");
//     setWebsite("");
//     setAddress("");
//     const fromData = new FormData();
//     fromData.append("related", e.value);
//     fromData.append("location", location);
//     try {
//       await axios({
//         method: "post",
//         url: `${configure.nodeApi}/related`,
//         data: fromData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);

//         // console.log("Related", res)

//         if (res.data.success === true) {
//           if (e.value == "introducer") {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           } else {
//             setLeadOption(
//               res.data.data.map((obj) => ({
//                 value: obj.id,
//                 label:
//                   obj.company +
//                   " - " +
//                   (obj.person_details[0]
//                     ? obj.person_details[0]?.person_name
//                     : "NA") +
//                   " - " +
//                   obj?.id,
//                 companyName: obj.company,
//                 address: obj.address,
//                 details: obj.person_details,
//                 website: obj.website,
//               })),
//             );
//           }
//         }
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onClientInfo = (e) => {
//     setSourceId(e);
//     setCompany_name(e?.companyName);

//     if (related?.value == "lead") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );
//       // setPersonEmail(e.details[0]?.person_email)
//       // setPersonName(e.details[0]?.person_name)
//       // setPersonPhone(e.person_phone)
//       setAddress(e.address);
//       setWebsite(e.website);
//     } else if (related?.value == "customer") {
//       setContactPersionOptions(
//         e.details.map((person) => ({
//           label: person.person_name,
//           value: person,
//         })),
//       );

//       setPersonEmail(e.details[0]?.email);
//       // setPersonName(e.details[0]?.person_name)
//       setPersonPhone(e.details[0]?.phone);
//       setAddress(e.address);
//       setWebsite(e.website);
//     }
//   };

//   const fetchStaffDetail = async (staffOption) => {
//     if (!staffOption) return;
//     try {
//       const res = await axios.get(
//         `${configure.apiUrl}/show/${staffOption.value}`,
//         {
//           headers: { Accept: "application/json" },
//         },
//       );
//       const staff = res.data.data.staff;
//       setProviderPerson(staffOption.label);
//       setProviderPhone(staff.contact_number || "");
//       setProviderEmail(staff.email || "");
//       setProviderAddress(
//         `${staff.ctname || "-"}, ${staff.sname || "-"}, ${staff.cname || "-"}`,
//       );
//     } catch (err) {
//       console.error("fetchStaffDetail error:", err);
//     }
//   };

//   const onStaffDetail = async (e) => {
//     setAssign(e);
//     setLoading(true);
//     await fetchStaffDetail(e);
//     setLoading(false);
//   };

//   // const onStaffDetail = async e => {
//   //   setProviderPerson(e.label)
//   //   setAssign(e)
//   //   setLoading(true)
//   //   try {
//   //     const response = await axios({
//   //       method: "get",
//   //       url: `${configure.apiUrl}/show/${e.value}`,
//   //       headers: {
//   //         Accept: "application/json",
//   //         "Content-Type": "multipart/form-data",
//   //       },
//   //     }).then(response => {
//   //       setProviderPhone(response.data.data.staff.contact_number)
//   //       setProviderEmail(response.data.data.staff.email)

//   //       let city, state, country

//   //       Object.keys(response.data.data.staff).forEach(obj => {
//   //         switch (obj) {
//   //           case "ctname":
//   //             city =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //           case "sname":
//   //             state =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //           case "cname":
//   //             country =
//   //               response.data.data.staff[obj] != null
//   //                 ? response.data.data.staff[obj]
//   //                 : "-"
//   //             break
//   //         }
//   //       })

//   //       setProviderAddress(`${city}, ${state}, ${country}`)

//   //       setLoading(false)
//   //     })
//   //   } catch (err) {
//   //     console.log(err)
//   //     setLoading(false)
//   //   }
//   // }

//   // Testing Rows on Change Event
//   const testingSr = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingMilestone = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };
//   const testingTime = (e, key) => {
//     const updatedArray = [...testingRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTestingRows(updatedArray);
//   };

//   // Terms and Aggrement on Change Event

//   const termsSr = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsService = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsCurrency = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };
//   const termsValue = (e, key) => {
//     const updatedArray = [...termsRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setTermsRows(updatedArray);
//   };

//   // Cost BreakDown on Change Event

//   const breakDescription = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakSr = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };
//   const breakTotal = (e, key) => {
//     const updatedArray = [...breakdownRows];
//     updatedArray[key] = {
//       ...updatedArray[key],
//       [e.target.name]: e.target.value,
//     };
//     setBreakdownRows(updatedArray);
//   };

//   const onEditProposal = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     const formData = new FormData();
//     formData.append("user_id", localStorage.getItem("auth_id"));
//     formData.append("proposal_id", params.id);
//     formData.append("proposaltitle", proposal_title);
//     formData.append("proposalsubtitle", proposal_subtitle);
//     formData.append("currency", currency?.value);
//     formData.append("date", date);
//     formData.append("opentill", till_date);
//     formData.append("related", related?.value);
//     formData.append("companyname", company_name);
//     formData.append(
//       "contactname",
//       person_name?.label ? person_name?.label : person_name,
//     );
//     formData.append("address", address);
//     formData.append("clientcontact", person_phone);
//     formData.append("email", person_email);
//     formData.append("website", website);
//     formData.append("assigned", assign?.value);
//     formData.append("company2", provider_company);
//     formData.append("contactnumber", provider_phone);
//     formData.append("address1", provider_address);
//     formData.append("providermail", provider_email);
//     formData.append("contact_member", provider_person);
//     formData.append("website1", provider_website);
//     formData.append("deliverytesting", JSON.stringify(testingRows));
//     formData.append("terms", JSON.stringify(termsRows));
//     formData.append("costbreakdown", JSON.stringify(breakdownRows));
//     formData.append("location", location);
//     formData.append("status", status?.value);
//     formData.append("conclusion_email", conclusion_email);
//     formData.append("conclusion_contact", conclusion_phone);
//     formData.append("source_name", source_id?.value);
//     formData.append("type", "General");
//     formData.append("introducer_id", introducerId?.value);
//     formData.append("template", template?.value || "1");
//     formData.append("timeline", JSON.stringify(timelineRows));
//     try {
//       const response = await axios({
//         method: "post",
//         url: `${configure.nodeApi}/edit_proposal`,
//         data: formData,
//         headers: {
//           Accept: "application/json",
//           "Content-Type": "multipart/form-data",
//         },
//       }).then((res) => {
//         setLoading(false);
//         swal({
//           icon: "success",
//           text: "Proposal Edited Succesfully",
//         }).then((data) => {
//           navigate(`${configure.appUrl}sales/proposal`);
//         });
//       });
//     } catch (error) {
//       console.log(error);
//       setLoading(false);
//     }
//   };

//   const onCurrency = (e, key) => {
//     let values = [...termsRows];
//     values[key][e.target.name] = e.target.value;
//     setTermsRow(values);
//   };

//   return (
//     <React.Fragment>
//       {isLoading && <Loader />}
//       <div className="ps-2">
//         <Row className="px-1">
//           <Form onSubmit={onEditProposal}>
//             {/* Fixed Buttons */}
//             <div
//               className={`flex-column fixed-buttons pt-2 ${
//                 fixButtons ? "d-flex" : "d-none"
//               }`}
//             >
//               <button className="btn btn-save btn-label pe-0  fix-btn">
//                 <i className="fas fa-save me-2 label-icon"></i>
//                 <span>Save</span>
//               </button>
//               <a
//                 onClick={() => navigate(-1)}
//                 className="btn btn-red  fix-btn btn-label pe-0"
//               >
//                 <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                 <span>Cancel</span>
//               </a>
//             </div>
//             {/* <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-3 mb-md-0 mb-3">
//                 <label htmlFor="">Introducer</label>
//                 <Select
//                   placeholder="Select Introducer"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={allIntroducers}
//                   value={introducerId}
//                   onChange={(e) => setIntroducerId(e)}
//                 />
//               </div>
              
//               <div className="col-md-3 mb-3"></div>
//               <div className="col-md-6 mb-3 text-end">
//                 <button className=" btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(-1);
//                   }}
//                   className=" btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row> */}

//             <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">
//               <div className="col-md-6 mb-md-0 mb-3">
//                 <div className="d-flex gap-3">
//                   <div className="flex-fill">
//                     <label htmlFor="">Introducer</label>
//                     <Select
//                       placeholder="Select Introducer"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       styles={colourStyles}
//                       options={allIntroducers}
//                       value={introducerId}
//                       onChange={(e) => setIntroducerId(e)}
//                     />
//                   </div>

//                   <div className="flex-fill">
//                     <label htmlFor="">Template</label>
//                     <Select
//                       placeholder="Select Template"
//                       className="basic-multi-select"
//                       classNamePrefix=" select"
//                       style={{ backgroundColor: "#f8f6ff" }}
//                       options={template_options}
//                       value={template}
//                       onChange={(e) => setTemplate(e)}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="col-md-6 mb-3 text-end d-flex align-items-end justify-content-end">
//                 <button className="btn ms-md-2 btn-save btn-label">
//                   <i className="fas fa-save me-1 label-icon"></i> save
//                 </button>
//                 <button
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(-1);
//                   }}
//                   className="btn ms-md-2 btn-red btn-label"
//                 >
//                   <i className="dripicons-cross me-2 icon-center label-icon"></i>
//                   CANCEL
//                 </button>
//               </div>
//             </Row>

//             {/* Service  info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Service Information</h5>

//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Title</label>
//                 <input
//                   type="text"
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   defaultValue="Software Development"
//                   placeholder="Enter Proposal Title"
//                   className="form-control "
//                   value={proposal_title}
//                   onChange={(e) => {
//                     setProposalTitle(e.target.value);
//                     let values = [...termsRows];
//                     values[1]["service"] = e.target.value;
//                     setTermsRows(values);
//                   }}
//                 />
//               </div>
//               <div className="col-md-6 mt-2 mb-3">
//                 <label htmlFor="">Proposal Subtitle</label>
//                 <input
//                   type="text"
//                   defaultValue="Zithas Mars - Payroll Management"
//                   placeholder="Enter Proposal Subtitle"
//                   className="form-control"
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   value={proposal_subtitle}
//                   onChange={(e) => setProposalSubTitle(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Status</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={status_option}
//                   style={{ backgroundColor: "#f8f6ff" }}
//                   value={status}
//                   onChange={(e) => setStatus(e)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Currency</label>
//                 <Select
//                   placeholder="Select Currency"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={currency_option}
//                   value={currency}
//                   onChange={(e) => setCurrency(e)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Date</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={date}
//                   onChange={(e) => setDate(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Open Till</label>
//                 <input
//                   type="date"
//                   className="form-control "
//                   value={till_date}
//                   onChange={(e) => setTillDate(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-2 mb-3 mb-md-0">
//                 <label htmlFor="">Related </label>
//                 <Select
//                   placeholder="Select"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={related_option}
//                   value={related}
//                   onChange={(e) => onChangeRelated(e)}
//                 />
//               </div>
//             </Row>

//             {/* Client  info */}
//             {template?.value !== "2" && (
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Client Information</h5>

//               {related?.label !== "Nothing Selected" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">{related?.label}</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={lead_option}
//                     value={source_id}
//                     onChange={(e) => onClientInfo(e)}
//                   />
//                 </div>
//               ) : null}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={company_name}
//                   onChange={(e) => setCompany_name(e.target.value)}
//                 />
//               </div>
//               {/* <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={person_name}
//                   onChange={e => setPersonName(e.target.value)}
//                 />
//               </div> */}

//               {related?.label == "Introducer" ? (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <input
//                     type="text"
//                     placeholder="Enter Contact Person"
//                     className="form-control "
//                     value={person_name}
//                     onChange={(e) => setPersonName(e.target.value)}
//                   />
//                 </div>
//               ) : (
//                 <div className="col-md-3 mt-2 mb-3">
//                   <label htmlFor="">Contact Person</label>
//                   <Select
//                     placeholder="Select"
//                     className="basic-multi-select"
//                     classNamePrefix=" select"
//                     styles={colourStyles}
//                     options={contact_name_options}
//                     value={person_name}
//                     onChange={(e) => {
//                       setPersonName(e);
//                       console.log(e);
//                       setPersonEmail(e?.value.person_email);
//                       setPersonPhone(e?.value.person_phone);
//                     }}
//                   />
//                 </div>
//               )}

//               <div className="col-md-3 mt-2 mb-3">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={address}
//                   onChange={(e) => setAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="number"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={person_phone}
//                   onChange={(e) => setPersonPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={person_email}
//                   onChange={(e) => setPersonEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mb-3 mb-md-0">
//                 <label htmlFor="">Website</label>

//                 <input
//                   type="text"
//                   placeholder="Enter URL"
//                   className="form-control "
//                   value={website}
//                   onChange={(e) => setWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>
//             )}

//             {/* Provider  info */}
//             {template?.value !== "2" && (
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Provider Information</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Assigned</label>
//                 <Select
//                   placeholder="Select Status"
//                   className="basic-multi-select"
//                   classNamePrefix=" select"
//                   styles={colourStyles}
//                   options={assign_option}
//                   value={assign}
//                   onChange={(e) => onStaffDetail(e)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact Person</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact Person"
//                   className="form-control "
//                   value={provider_person}
//                   onChange={(e) => setProviderPerson(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Contact</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Contact"
//                   className="form-control "
//                   value={provider_phone}
//                   onChange={(e) => setProviderPhone(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   defaultValue="gia@zithas.com"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={provider_email}
//                   onChange={(e) => setProviderEmail(e.target.value)}
//                 />
//               </div>

//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Company Name</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Company Name"
//                   className="form-control "
//                   value={provider_company}
//                   onChange={(e) => setProviderCompany(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Address</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Address"
//                   className="form-control "
//                   value={provider_address}
//                   onChange={(e) => setProviderAddress(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-4 mt-2 mt-3 ">
//                 <label htmlFor="">Website</label>
//                 <input
//                   type="text"
//                   placeholder="Enter Website"
//                   className="form-control "
//                   value={provider_website}
//                   onChange={(e) => setProviderWebsite(e.target.value)}
//                 />
//               </div>
//             </Row>
//             )}

//             {/* Deliverables & testing info */}
//             {template?.value !== "2" && (
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Deliverables & testing</h5>
//                 <a
//                   onClick={() => onAddTestingRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Milestone Description</th>
//                       <th>Estimated Time (In Weeks)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(testingRows || []).map((testingRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               value={testingRow["sr.no"]}
//                               className="form-control "
//                               onChange={(e) => testingSr(e, key)}
//                               name="sr.no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               value={testingRow.milestone}
//                               placeholder="Enter Description"
//                               className="form-control "
//                               onChange={(e) => testingMilestone(e, key)}
//                               name="milestone"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               value={testingRow.estimatedtime}
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               onChange={(e) => testingTime(e, key)}
//                               name="estimatedtime"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteTestingRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>
//             )}

//             {/* Terms and agreement */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Terms and agreement</h5>
//                 <a
//                   onClick={() => onAddTermsRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Particular</th>
//                       <th>Currency</th>
//                       <th>Total</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(termsRows || []).map((termsRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={termsRow.no}
//                               onChange={(e) => termsSr(e, key)}
//                               name="no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={termsRow.service}
//                               onChange={(e) => termsService(e, key)}
//                               name="service"
//                             />
//                           </td>
//                           <td className="col-1">
//                             <input
//                               type="text"
//                               className="form-control "
//                               value={currency?.symbol}
//                               // onChange={e => onCurrency(e, key)}
//                               // value={termsRow.currency}
//                               // onChange={e => termsCurrency(e, key)}
//                               name="currency"
//                               readOnly
//                             />
//                           </td>
//                           <td className="col-2">
//                             <input
//                               type="text"
//                               placeholder={
//                                 key == 0 ? "Estimated Time" : "Enter Total Cost"
//                               }
//                               className="form-control "
//                               value={termsRow.value ?? termsRow.total ?? ""}
//                               onChange={(e) => termsValue(e, key)}
//                               name="value"
//                               style={key === 2 ? { backgroundColor: "#f8f6ff" } : {}}
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key >= 1 ? (
//                               <a
//                                 onClick={() => onDeleteTermsRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* Cost Breakdown info */}
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <div className="d-flex justify-content-between">
//                 <h5 className="mb-3">Cost Breakdown</h5>
//                 <a
//                   onClick={() => onAddBreakdownRow()}
//                   className="btn btn-purple btn-label"
//                 >
//                   <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
//                   New Row
//                 </a>
//               </div>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
//                   <thead className="">
//                     <tr>
//                       <th>Sr No.</th>
//                       <th>Description</th>
//                       <th>Estimated Time (In Hours)</th>
//                       <th className="text-center">Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {(breakdownRows || []).map((breakdownRow, key) => {
//                       return (
//                         <tr key={key}>
//                           <td className="col-1">
//                             <input
//                               type="number"
//                               className="form-control "
//                               value={breakdownRow.sr_no}
//                               onChange={(e) => breakSr(e, key)}
//                               name="sr_no"
//                             />
//                           </td>
//                           <td className="col-7">
//                             <input
//                               type="text"
//                               placeholder="Enter Description"
//                               className="form-control "
//                               value={breakdownRow.description}
//                               onChange={(e) => breakDescription(e, key)}
//                               name="description"
//                             />
//                           </td>
//                           <td className="col-3">
//                             <input
//                               type="text"
//                               placeholder="Enter Estimated Time"
//                               className="form-control "
//                               value={breakdownRow.totalcost}
//                               onChange={(e) => breakTotal(e, key)}
//                               name="totalcost"
//                             />
//                           </td>
//                           <td className="col-1 text-center">
//                             {key !== 0 ? (
//                               <a
//                                 onClick={() => onDeleteBreakdownRow(key)}
//                                 className="btn btn-outline-danger"
//                               >
//                                 <i className="fas fa-trash-alt"></i>
//                               </a>
//                             ) : (
//                               "--"
//                             )}
//                           </td>
//                         </tr>
//                       );
//                     })}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>

//             {/* ── Project Timeline ── */}
//             {template?.value !== "2" && (
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Project Timeline</h5>
//               <div className="responsive-table">
//                 <Table className="table table-bordered mb-0 mt-2">
//                   <thead>
//                     <tr>
//                       <th style={{ color: "#fff", width: "7%" }}>Sr No.</th>
//                       <th style={{ color: "#fff", width: "25%" }}>Phase</th>
//                       <th style={{ color: "#fff", width: "10%" }}>Duration</th>
//                       <th style={{ color: "#fff" }}>Key Deliverables</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {timelineRows.map((row, key) => (
//                       <tr key={key}>
//                         <td className="text-center align-middle">{key + 1}</td>
//                         <td className="align-middle">{row.phase}</td>
//                         <td>
//                           <div className="input-group">
//                             {/* <span className="input-group-text">Wk</span> */}
//                             <input
//                               type="text"
//                               className="form-control"
//                               placeholder="e.g. 1 or 2–3"
//                               name="duration"
//                               value={row.duration}
//                               style={{ backgroundColor: "#f8f6ff" }}
//                               onChange={(e) => onTimelineChange(e, key)}
//                             />
//                           </div>
//                         </td>
//                         <td>
//                           <input
//                             type="text"
//                             className="form-control"
//                             placeholder="Enter key deliverables"
//                             style={{ backgroundColor: "#f8f6ff" }}
//                             name="deliverables"
//                             value={row.deliverables}
//                             onChange={(e) => onTimelineChange(e, key)}
//                           />
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </Table>
//               </div>
//             </Row>
//             )}

//             {/* Conclusion*/}
//             {template?.value !== "2" && (
//             <Row className="bg-white px-2 py-4 shadow mb-3">
//               <h5 className="mb-3">Conclusion</h5>

//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Email Id</label>
//                 <input
//                   type="email"
//                   placeholder="Enter Email Id"
//                   className="form-control "
//                   value={conclusion_email}
//                   onChange={(e) => setConclusionEmail(e.target.value)}
//                 />
//               </div>
//               <div className="col-md-3 mt-2 mb-3 mb-md-0">
//                 <label htmlFor="">Phone Number</label>
//                 <input
//                   type="text"
//                   value={conclusion_phone}
//                   onChange={(e) => setConclusionPhone(e.target.value)}
//                   placeholder="Enter Phone no."
//                   className="form-control "
//                 />
//               </div>
//             </Row>
//             )}

//           </Form>
//         </Row>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Profile;






















import React, { useState, useEffect } from "react";
import { Table } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Row, Form } from "reactstrap";
import Select from "react-select";
import Loader from "pages/Separate/Loader";
import axios from "axios";
import indiaFlag from "../../../../assets/images/flags/india.png";
import UkFlag from "../../../../assets/images/flags/uk.png";
import configure from "configure";
import Swal from "sweetalert2";

const Profile = () => {
  const [fixButtons, setFixButtons] = useState(false);
  const [testingRows, setTestingRows] = useState([{}]);
  const [breakdownRows, setBreakdownRows] = useState([{}]);
  
  // const [termsRows, setTermsRows] = useState([{}]);
  const [termsRows, setTermsRows] = useState([
    {
      no: "1",
      service: "Project duration",
      currency: "£",
      total: "",
    },
    {
      no: "2",
      service: "(Service Name)",
      currency: "£",
      total: "",
    },
    {
      no: "3",
      service: "Domain, Hosting, and SSL (Annual Charges)",
      currency: "£",
      total: "",
    },
  ]);

  // For Client information
  const [client, setClient] = useState([]);

  // for Provider Informtaion
  const [providerInfo, setProviderInfo] = useState({});
  const [relatedClient, setRelatedClient] = useState([]);

  const [template, setTemplate] = useState({ value: "1", label: "Template 1" });
  const template_options = [
    { label: "Template 1", value: "1" },
    { label: "Blank Template", value: "2" },
  ];

  // const FIXED_PHASES = [
  //   "Discovery & Strategy",
  //   "UI/UX Design",
  //   "Development",
  //   "Content Integration",
  //   "QA & Testing",
  //   "Deployment",
  // ];

  // const [timelineRows, setTimelineRows] = useState(
  //   FIXED_PHASES.map((phase) => ({ phase, duration: "", deliverables: "" })),
  // );

  const [timelineRows, setTimelineRows] = useState([
    { phase: "Discovery & Strategy", duration: "", deliverables: "" },
    { phase: "UI/UX Design", duration: "", deliverables: "" },
    { phase: "Development", duration: "", deliverables: "" },
    { phase: "Content Integration", duration: "", deliverables: "" },
    { phase: "QA & Testing", duration: "", deliverables: "" },
    { phase: "Deployment", duration: "", deliverables: "" },
  ]);

  const navigate = useNavigate();

  useEffect(() => {
    setLocation("India");
    setProviderInfo(ukProvider);

    setClient(introducer);
  }, []);

  // document.title = "Add General Proposal | Zithas Crm"

  // dynamic Testing form add-remove
  const onAddTestingRow = () => {
    setTestingRows([
      ...testingRows,
      { "sr.no": testingRows.length + 1, milestone: "", estimatedtime: "" },
    ]);
  };

  const onDeleteTestingRow = (index) => {
    const newInputs = [...testingRows];
    newInputs.splice(index, 1);
    setTestingRows(newInputs);
  };

  // dynamic breakdownRows Form add-remove
  const onAddBreakdownRow = () => {
    setBreakdownRows([
      ...breakdownRows,
      {},
    ]);
  };

  const onDeleteBreakdownRow = (index) => {
    const newInputs = [...breakdownRows];
    newInputs.splice(index, 1);
    setBreakdownRows(newInputs);
  };

  // dynamic Terms and agreement Form add-remove

  const onAddTermsRow = () => {
    setTermsRows([
      ...termsRows,
      { no: termsRows.length + 1, service: "", value: "" },
    ]);
  };

  const onDeleteTermsRow = (index) => {
    const newInputs = [...termsRows];
    newInputs.splice(index, 1);
    setTermsRows(newInputs);
  };

  const onTimelineChange = (e, key) => {
    const updated = [...timelineRows];
    updated[key] = { ...updated[key], [e.target.name]: e.target.value };
    setTimelineRows(updated);
  };

  document.addEventListener("scroll", () => {
    if (window.scrollY > 160) {
      setFixButtons(true);
    } else {
      setFixButtons(false);
    }
  });

  const colourStyles = {
    menuList: (styles) => ({
      ...styles,
      background: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 50,
    }),
  };

  // for select controls

  const related_option = [
    { label: "Lead", value: "lead" },
    { label: "Customer", value: "customer" },
    { label: "Introducer", value: "introducer" },
  ];
  // ------------------------

  // Clients
  const introducer = [
    { label: "Nothing Selected", value: "1" },
    { label: "Jack Smith", value: "2" },
    { label: "Test company", value: "3" },
    { label: "Zenith Tins", value: "4" },
    { label: "Julius Gohil", value: "5" },
    { label: "Test Introducer", value: "6" },
  ];

  const ukProvider = {
    companyName: "Zithas Technologies",
    address: "Bristol, United Kingdom",
    website: "https://www.zithas.co.uk",
  };

  //   All Use States
  const [isLoading, setLoading] = useState([]);
  const [location_option, setLocationOption] = useState([]);
  const [status_option, setStatusOption] = useState([]);
  const [assign_option, setAssignOption] = useState([]);
  const [currency_option, setCurrencyOption] = useState([]);
  const [location, setLocation] = useState([]);
  const [proposal_title, setProposalTitle] = useState("");
  const [proposal_subtitle, setProposalSubTitle] = useState("");
  const [status, setStatus] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [date, setDate] = useState("");
  const [till_date, setTillDate] = useState("");
  const [related, setRelated] = useState([]);
  const [lead_option, setLeadOption] = useState([]);
  const [company_name, setCompany_name] = useState("");
  const [address, setAddress] = useState("");
  const [website, setWebsite] = useState("");
  const [person_name, setPersonName] = useState("");
  const [person_email, setPersonEmail] = useState("");
  const [person_phone, setPersonPhone] = useState("");
  const [provider_company, setProviderCompany] = useState("");
  const [provider_address, setProviderAddress] = useState("");
  const [provider_website, setProviderWebsite] = useState("");
  const [provider_person, setProviderPerson] = useState("");
  const [provider_phone, setProviderPhone] = useState("");
  const [provider_email, setProviderEmail] = useState("");
  const [assign, setAssign] = useState([]);
  const [conclusion_email, setConclusionEmail] = useState("");
  const [conclusion_phone, setConclusionPhone] = useState("");
  const [source_id, setSourceId] = useState("");
  const [contact_name_options, setContactPersionOptions] = useState([]);
  const [allIntroducers, setIntroducerOption] = useState([]);
  const [introducerId, setIntroducerId] = useState([]);
  const [project_objective, setProjectObjective] = useState("");
  const [isGeneratingObjective, setIsGeneratingObjective] = useState(false);

  //   show Proposal Data api Fetch

  const params = useParams();

  useEffect(() => {
    FetchProposalData();
  }, []);

  const FetchProposalData = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("proposal_id", params.id);

    try {
      // ✅ Run proposal fetch + all dropdown APIs in parallel
      // const [response, curRes, statusRes] = await Promise.all([
      //   axios({
      //     method: "post",
      //     url: `${configure.nodeApi}/view_proposal`,
      //     data: formData,
      //     headers: {
      //       Accept: "application/json",
      //       "Content-Type": "multipart/form-data",
      //     },
      //   }),
      //   axios.get(`${configure.nodeApi}/currency`, {
      //     headers: { Accept: "application/json" },
      //   }),
      //   axios.get(`${configure.apiUrl}/proposal_status`, {
      //     headers: { Accept: "application/json" },
      //   }),
      // ]);
      const [response, curRes, statusRes, locRes] = await Promise.all([
  axios({
    method: "post",
    url: `${configure.nodeApi}/view_proposal`,
    data: formData,
    headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
  }),
  axios.get(`${configure.nodeApi}/currency`, {
    headers: { Accept: "application/json" },
  }),
  axios.get(`${configure.apiUrl}/proposal_status`, {
    headers: { Accept: "application/json" },
  }),
  axios.get(`${configure.nodeApi}/locations`, {   // ✅ added here
    headers: { Accept: "application/json" },
  }),
]);

      // ✅ Set currency options regardless of proposal data
      const curOptions = curRes.data.data.currency.map((item) => ({
        label: item.currency,
        value: item.id,
        symbol: item.symbol,
      }));
      setCurrencyOption(curOptions);

      // ✅ Set status options regardless of proposal data
      const statusOptions = statusRes.data.data.map((obj) => ({
        value: obj.id,
        label: obj.name,
      }));
      setStatusOption(statusOptions);

      const locOptions = locRes.data.locations.map((obj) => ({
  label: obj.location,
  value: obj.id,
  link: obj?.Link,
}));
setLocationOption(locOptions);

      const d = response.data.data[0];
      console.log("RAW proposal data:", d);

      // ✅ Set simple text fields safely
      if (d.proposaltitile && d.proposaltitile !== "null")
        setProposalTitle(d.proposaltitile);
      if (d.proposalsubtitle && d.proposalsubtitle !== "null")
        setProposalSubTitle(d.proposalsubtitle);
      if (d.date) setDate(d.date);
      if (d.opentill) setTillDate(d.opentill);
      if (d.companyname) setCompany_name(d.companyname);
      if (d.address && d.address !== "null") setAddress(d.address);
      if (d.cilentcontact && d.cilentcontact !== "null")
        setPersonPhone(d.cilentcontact);
      if (d.email && d.email !== "null") setPersonEmail(d.email);
      if (d.website && d.website !== "null") setWebsite(d.website);
      if (d.contactmember) setProviderPerson(d.contactmember);
      if (d.contact) setProviderPhone(d.contact);
      if (d.provideremail) setProviderEmail(d.provideremail);
      if (d.company2) setProviderCompany(d.company2);
      if (d.address1) setProviderAddress(d.address1);
      if (d.website1 && d.website1 !== "null") setProviderWebsite(d.website1);
      if (d.conclusion_email && d.conclusion_email !== "null")
        setConclusionEmail(d.conclusion_email);
      if (d.conclusion_contact && d.conclusion_contact !== "null")
        setConclusionPhone(d.conclusion_contact);
      if (d.template) {
        setTemplate(
          template_options.find((o) => o.value == d.template) || {
            value: "1",
            label: "Template 1",
          },
        );
      }
      if (d.timeline) {
        try {
          const saved = JSON.parse(d.timeline);
          // setTimelineRows(
          //   FIXED_PHASES.map((phase, i) => ({
          //     phase,
          //     duration: saved[i]?.duration || "",
          //     deliverables: saved[i]?.deliverables || "",
          //   })),
          // );
          setTimelineRows(
            saved.map((row) => ({
              phase: row.phase || "",
              duration: row.duration || "",
              deliverables: row.deliverables || "",
            })),
          );
        } catch {
          // leave defaults
        }
      }
      if (d.project_objective && d.project_objective !== "null")
        setProjectObjective(d.project_objective);

      try {
        setTestingRows(JSON.parse(d.deliverytesting) || [{}]);
      } catch {
        setTestingRows([{}]);
      }
      try {
        setTermsRows(JSON.parse(d.terms) || [{}]);
      } catch {
        setTermsRows([{}]);
      }
      try {
        setBreakdownRows(JSON.parse(d.costbreakdown) || [{}]);
      } catch {
        setBreakdownRows([{}]);
      }

      // ✅ Match dropdowns with proposal data
      setCurrency(curOptions.find((obj) => obj.value == d.currency_id) || null);
      setStatus(statusOptions.find((obj) => obj.value == d.status) || null);
      setRelated(related_option.find((obj) => obj.value === d.related) || null);

      // ✅ location — use fallback if null
      
      const locationId = d.location || 1;
      const matchedLocation = locOptions.find((obj) => obj.value == locationId);
setLocation(matchedLocation || null);

      // ✅ lead_belong for assignee + introducer options (always call regardless)
      const belongForm = new FormData();
      belongForm.append("country_id", locationId);
      const belongRes = await axios({
        method: "post",
        url: `${configure.apiUrl}/lead_belong`,
        data: belongForm,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      });

      const assignOptions =
        belongRes.data.data.assigned?.map((item) => ({
          value: item.id,
          label: item.name,
        })) || [];
      setAssignOption(assignOptions);
      // setAssign(assignOptions.find(obj => obj.value == d.assignd) || null)

      const matchedAssign =
        assignOptions.find((obj) => obj.value == d.assignd) || null;
      setAssign(matchedAssign);
      if (matchedAssign) await fetchStaffDetail(matchedAssign); // ✅ auto-fill

      const introducerOptions =
        belongRes.data.data.introducer?.map((obj) => ({
          label: obj.company,
          value: obj.id,
        })) || [];
      setIntroducerOption(introducerOptions);
      setIntroducerId(
        introducerOptions.find((obj) => obj.value == d.introducer_id) || null,
      );

      // ✅ related clients — only call if related is set
      if (d.related) {
        const relatedForm = new FormData();
        relatedForm.append("related", d.related);
        relatedForm.append("location", locationId);
        const relatedRes = await axios({
          method: "post",
          url: `${configure.nodeApi}/related`,
          data: relatedForm,
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        });

        let leadOptions = [];
        if (d.related === "introducer") {
          leadOptions = relatedRes.data.data.map((obj) => ({
            value: obj.id,
            label: obj.company,
            address: obj.address,
            details: obj.person_details,
            website: obj.website,
          }));
        } else {
          leadOptions = relatedRes.data.data.map((obj) => ({
            value: obj.id,
            label: `${obj.company || "N/A"} - ${
              obj.person_details?.[0]?.person_name || "NA"
            } - ${obj.id}`,
            companyName: obj.company,
            address: obj.address,
            details: obj.person_details,
            website: obj.website,
          }));
        }
        setLeadOption(leadOptions);

        const selectedSource =
          leadOptions.find((obj) => obj.value == d.source_name) || null;
        setSourceId(selectedSource);
        if (selectedSource?.companyName)
          setCompany_name(selectedSource.companyName);

        if (selectedSource?.details) {
          const contactOptions = selectedSource.details.map((person) => ({
            label: person.person_name,
            value: person,
          }));
          setContactPersionOptions(contactOptions);
          setPersonName(
            contactOptions.find((item) => item.label === d.contactname) || null,
          );
        } else {
          setPersonName(d.contactname || "");
        }
      }
    } catch (err) {
      console.error("FetchProposalData error:", err);
    } finally {
      setLoading(false);
    }
  };

  const onChangeCountry = async (e) => {
  setLocation(e);
  setLoading(true);

  if (e.value == 1) {
    setProviderCompany("Zithas Technologies Pvt. Ltd.");
    setProviderWebsite("www.zithas.com");
  } else if (e.value == 2) {
    setProviderCompany("Zithas Technologies Ltd.");
    setProviderWebsite("www.zithas.co.uk");
  }

  const formData = new FormData();
  formData.append("country_id", e.value);
  try {
    await axios({
      method: "post",
      url: `${configure.apiUrl}/lead_belong`,
      data: formData,
      headers: { Accept: "application/json", "Content-Type": "multipart/form-data" },
    }).then((res) => {
      setAssignOption(res.data.data.assigned?.map((item) => ({ value: item.id, label: item.name })));
      setIntroducerOption(res?.data?.data?.introducer?.map((obj) => ({ label: obj.company, value: obj.id })));
      setLoading(false);
    });
  } catch (error) {
    console.log(error);
    setLoading(false);
  }
};


  const onChangeRelated = async (e) => {
    console.log(e);
    setRelated(e);
    setRelatedClient(e);
    setLoading(true);
    setPersonEmail("");
    setPersonName("");
    setPersonPhone("");
    setSourceId([]);
    setCompany_name("");
    setWebsite("");
    setAddress("");
    const fromData = new FormData();
    fromData.append("related", e.value);
    fromData.append("location", location);
    try {
      await axios({
        method: "post",
        url: `${configure.nodeApi}/related`,
        data: fromData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);

        // console.log("Related", res)

        if (res.data.success === true) {
          if (e.value == "introducer") {
            setLeadOption(
              res.data.data.map((obj) => ({
                value: obj.id,
                label: obj.company,
                address: obj.address,
                details: obj.person_details,
                website: obj.website,
              })),
            );
          } else {
            setLeadOption(
              res.data.data.map((obj) => ({
                value: obj.id,
                label:
                  obj.company +
                  " - " +
                  (obj.person_details[0]
                    ? obj.person_details[0]?.person_name
                    : "NA") +
                  " - " +
                  obj?.id,
                companyName: obj.company,
                address: obj.address,
                details: obj.person_details,
                website: obj.website,
              })),
            );
          }
        }
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onClientInfo = (e) => {
    setSourceId(e);
    setCompany_name(e?.companyName);

    if (related?.value == "lead") {
      setContactPersionOptions(
        e.details.map((person) => ({
          label: person.person_name,
          value: person,
        })),
      );
      // setPersonEmail(e.details[0]?.person_email)
      // setPersonName(e.details[0]?.person_name)
      // setPersonPhone(e.person_phone)
      setAddress(e.address);
      setWebsite(e.website);
    } else if (related?.value == "customer") {
      setContactPersionOptions(
        e.details.map((person) => ({
          label: person.person_name,
          value: person,
        })),
      );

      setPersonEmail(e.details[0]?.email);
      // setPersonName(e.details[0]?.person_name)
      setPersonPhone(e.details[0]?.phone);
      setAddress(e.address);
      setWebsite(e.website);
    }
  };

  // const fetchStaffDetail = async (staffOption) => {
  //   if (!staffOption) return;
  //   try {
  //     const res = await axios.get(
  //       `${configure.apiUrl}/show/${staffOption.value}`,
  //       {
  //         headers: { Accept: "application/json" },
  //       },
  //     );
  //     const staff = res.data.data.staff;
  //     setProviderPerson(staffOption.label);
  //     setProviderPhone(staff.contact_number || "");
  //     setProviderEmail(staff.email || "");
  //     setProviderAddress(
  //       `${staff.ctname || "-"}, ${staff.sname || "-"}, ${staff.cname || "-"}`,
  //     );
  //   } catch (err) {
  //     console.error("fetchStaffDetail error:", err);
  //   }
  // };

  const fetchStaffDetail = async (staffOption) => {
  if (!staffOption) return;
  try {
    const res = await axios.get(
      `${configure.apiUrl}/show/${staffOption.value}`,
      { headers: { Accept: "application/json" } },
    );
    const staff = res.data.data.staff;
    setProviderPerson(staffOption.label);
    setProviderPhone(staff.phone_number || staff.contact_number || "");  // ✅ fix
    setProviderEmail(staff.email || "");
    setProviderAddress(
      `${staff.ctname || "-"}, ${staff.sname || "-"}, ${staff.cname || "-"}`,
    );
  } catch (err) {
    console.error("fetchStaffDetail error:", err);
  }
};

  const onStaffDetail = async (e) => {
    setAssign(e);
    setLoading(true);
    await fetchStaffDetail(e);
    setLoading(false);
  };

  // Testing Rows on Change Event
  const testingSr = (e, key) => {
    const updatedArray = [...testingRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTestingRows(updatedArray);
  };
  const testingMilestone = (e, key) => {
    const updatedArray = [...testingRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTestingRows(updatedArray);
  };
  const testingTime = (e, key) => {
    const updatedArray = [...testingRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTestingRows(updatedArray);
  };

  // Terms and Aggrement on Change Event

  const termsSr = (e, key) => {
    const updatedArray = [...termsRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTermsRows(updatedArray);
  };
  const termsService = (e, key) => {
    const updatedArray = [...termsRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTermsRows(updatedArray);
  };
  const termsCurrency = (e, key) => {
    const updatedArray = [...termsRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTermsRows(updatedArray);
  };
  const termsValue = (e, key) => {
    const updatedArray = [...termsRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setTermsRows(updatedArray);
  };

  // Cost BreakDown on Change Event

  const breakDescription = (e, key) => {
    const updatedArray = [...breakdownRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setBreakdownRows(updatedArray);
  };
  const breakSr = (e, key) => {
    const updatedArray = [...breakdownRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setBreakdownRows(updatedArray);
  };
  const breakTotal = (e, key) => {
    const updatedArray = [...breakdownRows];
    updatedArray[key] = {
      ...updatedArray[key],
      [e.target.name]: e.target.value,
    };
    setBreakdownRows(updatedArray);
  };

  const generateObjective = async () => {
    if (!source_id?.value) {
      return Swal.fire({ icon: "warning", text: "Please select a lead first" });
    }
    setIsGeneratingObjective(true);
    try {
      const rfpRes = await axios.get(
        `${configure.nodeApi}/get_rfp_by_lead/${source_id.value}`,
        { headers: { Accept: "application/json" } },
      );
      if (!rfpRes.data.success || !rfpRes.data.data) {
        return Swal.fire({
          icon: "warning",
          text: "No RFP found for this lead to generate objective",
        });
      }
      const rfp = rfpRes.data.data;
      const features = (() => {
        try {
          const r = rfp.features;
          return typeof r === "string" ? JSON.parse(r) : r || [];
        } catch {
          return [];
        }
      })();
      const services = (() => {
        try {
          const r = rfp.services;
          return typeof r === "string" ? JSON.parse(r) : r || [];
        } catch {
          return [];
        }
      })();
      const res = await axios.post(
        `${configure.nodeApi}/generate_project_objective`,
        { company_name: company_name || "The Client", features, services },
        { headers: { Accept: "application/json" } },
      );
      if (res.data.success) {
        setProjectObjective(res.data.objective);
      } else {
        Swal.fire({ icon: "error", text: "Failed to generate objective" });
      }
    } catch (err) {
      console.error("generateObjective error:", err);
      Swal.fire({ icon: "error", text: "Failed to generate objective" });
    } finally {
      setIsGeneratingObjective(false);
    }
  };

  const onEditProposal = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = new FormData();
    formData.append("user_id", localStorage.getItem("auth_id"));
    formData.append("proposal_id", params.id);
    formData.append("proposaltitle", proposal_title);
    formData.append("proposalsubtitle", proposal_subtitle);
    formData.append("currency", currency?.value);
    formData.append("date", date);
    formData.append("opentill", till_date);
    formData.append("related", related?.value);
    formData.append("companyname", company_name);
    formData.append(
      "contactname",
      person_name?.label ? person_name?.label : person_name,
    );
    formData.append("address", address);
    formData.append("clientcontact", person_phone);
    formData.append("email", person_email);
    formData.append("website", website);
    formData.append("assigned", assign?.value);
    formData.append("company2", provider_company);
    formData.append("contactnumber", provider_phone);
    formData.append("address1", provider_address);
    formData.append("providermail", provider_email);
    formData.append("contact_member", provider_person);
    formData.append("website1", provider_website);
    formData.append("deliverytesting", JSON.stringify(testingRows));
    formData.append("terms", JSON.stringify(termsRows));
    formData.append("costbreakdown", JSON.stringify(breakdownRows));
    formData.append("location", location?.value ?? "");
    formData.append("status", status?.value);
    formData.append("conclusion_email", conclusion_email);
    formData.append("conclusion_contact", conclusion_phone);
    formData.append("source_name", source_id?.value);
    formData.append("type", "General");
    formData.append("introducer_id", introducerId?.value);
    formData.append("template", template?.value || "1");
    formData.append("timeline", JSON.stringify(timelineRows));
    formData.append("project_objective", project_objective);
    try {
      const response = await axios({
        method: "post",
        url: `${configure.nodeApi}/edit_proposal`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      }).then((res) => {
        setLoading(false);
        swal({
          icon: "success",
          text: "Proposal Edited Succesfully",
        }).then((data) => {
          navigate(`${configure.appUrl}sales/proposal`);
        });
      });
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const onCurrency = (e, key) => {
    let values = [...termsRows];
    values[key][e.target.name] = e.target.value;
    setTermsRow(values);
  };

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="ps-2">
        <Row className="px-1">
          <Form onSubmit={onEditProposal}>
            {/* Fixed Buttons */}
            <div
              className={`flex-column fixed-buttons pt-2 ${
                fixButtons ? "d-flex" : "d-none"
              }`}
            >
              <button className="btn btn-save btn-label pe-0  fix-btn">
                <i className="fas fa-save me-2 label-icon"></i>
                <span>Save</span>
              </button>
              <a
                onClick={() => navigate(-1)}
                className="btn btn-red  fix-btn btn-label pe-0"
              >
                <i className="dripicons-cross me-2 icon-center label-icon"></i>
                <span>Cancel</span>
              </a>
            </div>
            

            {/* <Row className="bg-white px-2 justify-content-between py-4 shadow mb-3">

              <div className="col-md-3 mb-3 mb-md-0">
    <label>Location <span className="text-danger">*</span></label>
    <div className="d-flex flex-wrap gap-3" style={{ height: "38px", alignItems: "center" }}>
      {location_option.map((item, i) => {
        const isSelected = String(location?.value) === String(item.value);
        return (
          <div
            key={i}
            onClick={() => onChangeCountry(item)}
            style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
          >
            <div style={{
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              border: `2px solid ${isSelected ? "#7B5EA7" : "#aaa"}`,
              backgroundColor: isSelected ? "#7B5EA7" : "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}>
              {isSelected && (
                <div style={{ width: "7px", height: "7px", borderRadius: "50%", backgroundColor: "#fff" }} />
              )}
            </div>
            <img src={item?.link} alt={item?.label || "flag"} width="28" height="18" style={{ display: "block", borderRadius: "2px" }} />
          </div>
        );
      })}
    </div>
  </div>

              <div className="col-md-6 mb-md-0 mb-3">
                <div className="d-flex gap-3">
                  <div className="flex-fill">
                    <label htmlFor="">Introducer</label>
                    <Select
                      placeholder="Select Introducer"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={allIntroducers}
                      value={introducerId}
                      onChange={(e) => setIntroducerId(e)}
                    />
                  </div>

                  <div className="flex-fill">
                    <label htmlFor="">Template</label>
                    <Select
                      placeholder="Select Template"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      style={{ backgroundColor: "#f8f6ff" }}
                      options={template_options}
                      value={template}
                      onChange={(e) => setTemplate(e)}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-6 mb-3 text-end d-flex align-items-end justify-content-end">
                <button className="btn ms-md-2 btn-save btn-label">
                  <i className="fas fa-save me-1 label-icon"></i> save
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            </Row> */}

                          <Row className="bg-white px-2 py-4 shadow mb-3 align-items-end">
            {/* Location */}
            <div className="col-md-3 mb-3 mb-md-0">
              <label>Location <span className="text-danger">*</span></label>
              <div 
                className="d-flex flex-wrap gap-3"
                style={{ height: "38px", alignItems: "center" }} 
              >
                {location_option.map((item, i) => {
                  const isSelected = String(location?.value) === String(item.value);
                  return (
                    <div
                      key={i}
                      onClick={() => onChangeCountry(item)}
                      style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}
                    >
                      <div style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        border: `2px solid ${isSelected ? "#7B5EA7" : "#aaa"}`,
                        backgroundColor: isSelected ? "#7B5EA7" : "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}>
                        {isSelected && (
                          <div style={{
                            width: "7px",
                            height: "7px",
                            borderRadius: "50%",
                            backgroundColor: "#fff",
                          }} />
                        )}
                      </div>
                      <img
                        src={item?.link}
                        alt={item?.label || "flag"}
                        width="28"
                        height="18"
                        style={{ display: "block", borderRadius: "2px" }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            
              {/* Introducer */}
              <div className="col-md-3 mb-3 mb-md-0">
                <label htmlFor="">Introducer</label>
                <Select
                  placeholder="Select Introducer"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={allIntroducers}
                  value={introducerId}
                  onChange={(e) => setIntroducerId(e)}
                />
              </div>
            
              {/* Template */}
              <div className="col-md-3 mb-3 mb-md-0">
                <label htmlFor="">Proposal Template <span className="text-danger">*</span></label>
                <Select
                  placeholder="Select Template"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  styles={colourStyles}
                  options={template_options}
                  value={template}
                  onChange={(e) => setTemplate(e)}
                />
              </div>
            
              {/* Buttons */}
              <div className="col-md-3 mb-3 mb-md-0 text-end">
                <button className="btn ms-md-2 btn-save btn-label">
                  <i className="fas fa-save me-1 label-icon"></i> save
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(-1);
                  }}
                  className="btn ms-md-2 btn-red btn-label"
                >
                  <i className="dripicons-cross me-2 icon-center label-icon"></i>
                  CANCEL
                </button>
              </div>
            
            </Row>

            {/* Service  info */}
            <Row className="bg-white px-2 py-4 shadow mb-3">
              <h5 className="mb-3">Service Information</h5>

              <div className="col-md-6 mt-2 mb-3">
                <label htmlFor="">Proposal Title</label>
                <input
                  type="text"
                  style={{ backgroundColor: "#f8f6ff" }}
                  defaultValue="Software Development"
                  placeholder="Enter Proposal Title"
                  className="form-control "
                  value={proposal_title}
                  onChange={(e) => {
                    setProposalTitle(e.target.value);
                    let values = [...termsRows];
                    values[1]["service"] = e.target.value;
                    setTermsRows(values);
                  }}
                />
              </div>
              <div className="col-md-6 mt-2 mb-3">
                <label htmlFor="">Proposal Subtitle</label>
                <input
                  type="text"
                  defaultValue="Zithas Mars - Payroll Management"
                  placeholder="Enter Proposal Subtitle"
                  className="form-control"
                  style={{ backgroundColor: "#f8f6ff" }}
                  value={proposal_subtitle}
                  onChange={(e) => setProposalSubTitle(e.target.value)}
                />
              </div>
              <div className="col-md-3 mb-3 mb-md-0">
                <label htmlFor="">Status</label>
                <Select
                  placeholder="Select Status"
                  className="basic-multi-select"
                  classNamePrefix=" select"
                  styles={colourStyles}
                  options={status_option}
                  style={{ backgroundColor: "#f8f6ff" }}
                  value={status}
                  onChange={(e) => setStatus(e)}
                />
              </div>
              <div className="col-md-3 mb-3 mb-md-0">
                <label htmlFor="">Currency</label>
                <Select
                  placeholder="Select Currency"
                  className="basic-multi-select"
                  classNamePrefix=" select"
                  styles={colourStyles}
                  options={currency_option}
                  value={currency}
                  onChange={(e) => setCurrency(e)}
                />
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <label htmlFor="">Date</label>
                <input
                  type="date"
                  className="form-control "
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                />
              </div>

              <div className="col-md-2 mb-3 mb-md-0">
                <label htmlFor="">Open Till</label>
                <input
                  type="date"
                  className="form-control "
                  value={till_date}
                  onChange={(e) => setTillDate(e.target.value)}
                />
              </div>
              <div className="col-md-2 mb-3 mb-md-0">
                <label htmlFor="">Related </label>
                <Select
                  placeholder="Select"
                  className="basic-multi-select"
                  classNamePrefix=" select"
                  styles={colourStyles}
                  options={related_option}
                  value={related}
                  onChange={(e) => onChangeRelated(e)}
                />
              </div>
            </Row>

            {/* Client  info */}
            {template?.value !== "2" && (
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Client Information</h5>

                {related?.label !== "Nothing Selected" ? (
                  <div className="col-md-3 mt-2 mb-3">
                    <label htmlFor="">{related?.label}</label>
                    <Select
                      placeholder="Select"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={lead_option}
                      value={source_id}
                      onChange={(e) => onClientInfo(e)}
                    />
                  </div>
                ) : null}

                <div className="col-md-3 mt-2 mb-3">
                  <label htmlFor="">Company Name</label>
                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    className="form-control "
                    value={company_name}
                    onChange={(e) => setCompany_name(e.target.value)}
                  />
                </div>

                {related?.label == "Introducer" ? (
                  <div className="col-md-3 mt-2 mb-3">
                    <label htmlFor="">Contact Person</label>
                    <input
                      type="text"
                      placeholder="Enter Contact Person"
                      className="form-control "
                      value={person_name}
                      onChange={(e) => setPersonName(e.target.value)}
                    />
                  </div>
                ) : (
                  <div className="col-md-3 mt-2 mb-3">
                    <label htmlFor="">Contact Person</label>
                    <Select
                      placeholder="Select"
                      className="basic-multi-select"
                      classNamePrefix=" select"
                      styles={colourStyles}
                      options={contact_name_options}
                      value={person_name}
                      onChange={(e) => {
                        setPersonName(e);
                        console.log(e);
                        setPersonEmail(e?.value.person_email);
                        setPersonPhone(e?.value.person_phone);
                      }}
                    />
                  </div>
                )}

                <div className="col-md-3 mt-2 mb-3">
                  <label htmlFor="">Address</label>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className="form-control "
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <label htmlFor="">Contact</label>
                  <input
                    type="number"
                    placeholder="Enter Contact"
                    className="form-control "
                    value={person_phone}
                    onChange={(e) => setPersonPhone(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <label htmlFor="">Email Id</label>
                  <input
                    type="email"
                    placeholder="Enter Email Id"
                    className="form-control "
                    value={person_email}
                    onChange={(e) => setPersonEmail(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <label htmlFor="">Website</label>

                  <input
                    type="text"
                    placeholder="Enter URL"
                    className="form-control "
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                </div>
              </Row>
            )}

            {/* Provider  info */}
            {template?.value !== "2" && (
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Provider Information</h5>

                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Assigned</label>
                  <Select
                    placeholder="Select Status"
                    className="basic-multi-select"
                    classNamePrefix=" select"
                    styles={colourStyles}
                    options={assign_option}
                    value={assign}
                    onChange={(e) => onStaffDetail(e)}
                  />
                </div>
                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Contact Person</label>
                  <input
                    type="text"
                    placeholder="Enter Contact Person"
                    className="form-control "
                    value={provider_person}
                    onChange={(e) => setProviderPerson(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Contact</label>
                  <input
                    type="text"
                    placeholder="Enter Contact"
                    className="form-control "
                    value={provider_phone}
                    onChange={(e) => setProviderPhone(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Email Id</label>
                  <input
                    type="email"
                    defaultValue="gia@zithas.com"
                    placeholder="Enter Email Id"
                    className="form-control "
                    value={provider_email}
                    onChange={(e) => setProviderEmail(e.target.value)}
                  />
                </div>

                <div className="col-md-4 mt-2 mt-3 ">
                  <label htmlFor="">Company Name</label>
                  <input
                    type="text"
                    placeholder="Enter Company Name"
                    className="form-control "
                    value={provider_company}
                    onChange={(e) => setProviderCompany(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mt-2 mt-3 ">
                  <label htmlFor="">Address</label>
                  <input
                    type="text"
                    placeholder="Enter Address"
                    className="form-control "
                    value={provider_address}
                    onChange={(e) => setProviderAddress(e.target.value)}
                  />
                </div>
                <div className="col-md-4 mt-2 mt-3 ">
                  <label htmlFor="">Website</label>
                  <input
                    type="text"
                    placeholder="Enter Website"
                    className="form-control "
                    value={provider_website}
                    onChange={(e) => setProviderWebsite(e.target.value)}
                  />
                </div>
              </Row>
            )}

            {/* Deliverables & testing info */}
            {template?.value !== "2" && (
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between">
                  <h5 className="mb-3">Deliverables & testing</h5>
                  <a
                    onClick={() => onAddTestingRow()}
                    className="btn btn-purple btn-label"
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>{" "}
                    Add New Row
                  </a>
                </div>
                <div className="responsive-table">
                  <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                    <thead className="">
                      <tr>
                        <th>Sr No.</th>
                        <th>Milestone Description</th>
                        <th>Estimated Time (In Weeks)</th>
                        <th className="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(testingRows || []).map((testingRow, key) => {
                        return (
                          <tr key={key}>
                            <td className="col-1">
                              <input
                                type="number"
                                value={testingRow["sr.no"]}
                                className="form-control "
                                onChange={(e) => testingSr(e, key)}
                                name="sr.no"
                              />
                            </td>
                            <td className="col-7">
                              <input
                                type="text"
                                value={testingRow.milestone}
                                placeholder="Enter Description"
                                className="form-control "
                                onChange={(e) => testingMilestone(e, key)}
                                name="milestone"
                              />
                            </td>
                            <td className="col-3">
                              <input
                                type="text"
                                value={testingRow.estimatedtime}
                                placeholder="Enter Estimated Time"
                                className="form-control "
                                onChange={(e) => testingTime(e, key)}
                                name="estimatedtime"
                              />
                            </td>
                            <td className="col-1 text-center">
                              {key !== 0 ? (
                                <a
                                  onClick={() => onDeleteTestingRow(key)}
                                  className="btn btn-outline-danger"
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </Row>
            )}

            {/* Terms and agreement */}
            <Row className="bg-white px-2 py-4 shadow mb-3">
              <div className="d-flex justify-content-between">
                <h5 className="mb-3">Terms and agreement</h5>
                <a
                  onClick={() => onAddTermsRow()}
                  className="btn btn-purple btn-label"
                >
                  <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
                  New Row
                </a>
              </div>
              <div className="responsive-table">
                <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                  <thead className="">
                    <tr>
                      <th>Sr No.</th>
                      <th>Particular</th>
                      <th>Currency</th>
                      <th>Total</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(termsRows || []).map((termsRow, key) => {
                      return (
                        <tr key={key}>
                          <td className="col-1">
                            <input
                              type="number"
                              className="form-control "
                              value={termsRow.no}
                              onChange={(e) => termsSr(e, key)}
                              name="no"
                            />
                          </td>
                          <td className="col-7">
                            <input
                              type="text"
                              placeholder="Enter Description"
                              className="form-control "
                              value={termsRow.service}
                              onChange={(e) => termsService(e, key)}
                              name="service"
                            />
                          </td>
                          <td className="col-1">
                            <input
                              type="text"
                              className="form-control "
                              value={currency?.symbol}
                              // onChange={e => onCurrency(e, key)}
                              // value={termsRow.currency}
                              // onChange={e => termsCurrency(e, key)}
                              name="currency"
                              readOnly
                            />
                          </td>
                          <td className="col-2">
                            <input
                              type="text"
                              placeholder={
                                key == 0 ? "Estimated Time" : "Enter Total Cost"
                              }
                              className="form-control "
                              value={termsRow.value ?? termsRow.total ?? ""}
                              onChange={(e) => termsValue(e, key)}
                              name="value"
                              style={
                                key === 2 ? { backgroundColor: "#f8f6ff" } : {}
                              }
                            />
                          </td>
                          <td className="col-1 text-center">
                            {key >= 1 ? (
                              <a
                                onClick={() => onDeleteTermsRow(key)}
                                className="btn btn-outline-danger"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Row>


            <Row className="bg-white px-2 py-4 shadow mb-3">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Project Objective</h5>
                <button
                  type="button"
                  className="btn btn-purple btn-label"
                  onClick={generateObjective}
                  disabled={isGeneratingObjective}
                >
                  <i
                    className={`fas ${
                      isGeneratingObjective ? "fa-spinner fa-spin" : "fa-magic"
                    } me-2 label-icon`}
                  ></i>
                  {isGeneratingObjective ? "Generating..." : "Generate with AI"}
                </button>
              </div>
              <div className="col-md-12">
                <textarea
                  className="form-control"
                  rows={6}
                  placeholder="AI-generated project objective will appear here. Click 'Generate with AI' or type manually."
                  value={project_objective}
                  onChange={(e) => setProjectObjective(e.target.value)}
                />
              </div>
            </Row>

            {/* Cost Breakdown info */}
            <Row className="bg-white px-2 py-4 shadow mb-3">
              <div className="d-flex justify-content-between">
                <h5 className="mb-3">Cost Breakdown</h5>
                <a
                  onClick={() => onAddBreakdownRow()}
                  className="btn btn-purple btn-label"
                >
                  <i className="fas fa-plus me-2 icon-size label-icon"></i> Add
                  New Row
                </a>
              </div>
              <div className="responsive-table">
                <Table className="table table-bordered mb-0 table-striped mt-3 table-hover">
                  <thead className="">
                    <tr>
                      <th>Sr No.</th>
                      <th>Description</th>
                      <th>Estimated Time (In Hours)</th>
                      <th className="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(breakdownRows || []).map((breakdownRow, key) => {
                      return (
                        <tr key={key}>
                          <td className="col-1">
                            <input
                              type="number"
                              className="form-control "
                              value={breakdownRow.no}
                              onChange={(e) => breakSr(e, key)}
                              name="sr_no"
                            />
                          </td>
                          <td className="col-7">
                            <input
                              type="text"
                              placeholder="Enter Description"
                              className="form-control "
                              value={breakdownRow.description}
                              onChange={(e) => breakDescription(e, key)}
                              name="description"
                            />
                          </td>
                          <td className="col-3">
                            <input
                              type="text"
                              placeholder="Enter Estimated Time"
                              className="form-control "
                              value={breakdownRow.totalcost}
                              onChange={(e) => breakTotal(e, key)}
                              name="totalcost"
                            />
                          </td>
                          <td className="col-1 text-center">
                            {key !== 0 ? (
                              <a
                                onClick={() => onDeleteBreakdownRow(key)}
                                className="btn btn-outline-danger"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                            ) : (
                              "--"
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Row>

            {/* ── Project Timeline ── */}
            {template?.value !== "2" && (
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <div className="d-flex justify-content-between mb-3">
                  <h5 className="mb-0">Project Timeline</h5>
                  <a
                    onClick={() =>
                      setTimelineRows([
                        ...timelineRows,
                        { phase: "", duration: "", deliverables: "" },
                      ])
                    }
                    className="btn btn-purple btn-label"
                  >
                    <i className="fas fa-plus me-2 icon-size label-icon"></i>
                    Add New Row
                  </a>
                </div>
                <div className="responsive-table">
                  <Table className="table table-bordered mb-0 mt-2">
                    <thead>
                      <tr>
                        <th style={{  width: "5%" }}>Sr No.</th>
                        <th style={{  width: "22%" }}>Phase</th>
                        <th style={{  width: "10%" }}>
                          Duration
                        </th>
                        <th>Key Deliverables</th>
                        <th
                          style={{  width: "8%" }}
                          className="text-center"
                        >
                          Action
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {timelineRows.map((row, key) => (
                        <tr key={key}>
                          <td className="text-center align-middle">
                            {key + 1}
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Phase"
                              name="phase"
                              value={row.phase}
                              onChange={(e) => onTimelineChange(e, key)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="e.g. 1 or 2–3"
                              name="duration"
                              value={row.duration}
                              onChange={(e) => onTimelineChange(e, key)}
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter key deliverables"
                              name="deliverables"
                              value={row.deliverables}
                              onChange={(e) => onTimelineChange(e, key)}
                            />
                          </td>
                          <td className="text-center align-middle">
                              <a
                                onClick={() => {
                                  const updated = [...timelineRows];
                                  updated.splice(key, 1);
                                  setTimelineRows(updated);
                                }}
                                className="btn btn-danger"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Row>
            )}

            {/* Conclusion*/}
            {template?.value !== "2" && (
              <Row className="bg-white px-2 py-4 shadow mb-3">
                <h5 className="mb-3">Conclusion</h5>

                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Email Id</label>
                  <input
                    type="email"
                    placeholder="Enter Email Id"
                    className="form-control "
                    value={conclusion_email}
                    onChange={(e) => setConclusionEmail(e.target.value)}
                  />
                </div>
                <div className="col-md-3 mt-2 mb-3 mb-md-0">
                  <label htmlFor="">Phone Number</label>
                  <input
                    type="text"
                    value={conclusion_phone}
                    onChange={(e) => setConclusionPhone(e.target.value)}
                    placeholder="Enter Phone no."
                    className="form-control "
                  />
                </div>
              </Row>
            )}
          </Form>
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Profile;